(() => {
  const root = document.querySelector("[data-kob-makeup-preorder-control]");
  // Retain a reminder's destination across the existing account-login flow.
  // Only these operational selectors are stored; never identity tokens.
  if (root) {
    try {
      const url = new URL(window.location.href), key = "kob_makeup_supplier_return";
      if (url.searchParams.get("focus") === "coverage" && url.searchParams.get("release_id")) {
        const params = new URLSearchParams();
        ["release_id", "focus", "focus_sku", "focus_workbook", "order_draft_id"].forEach(name => { if (url.searchParams.has(name)) params.set(name, url.searchParams.get(name)); });
        sessionStorage.setItem(key, JSON.stringify({ search: params.toString(), at: Date.now() }));
      } else if (root.querySelector("[data-kob-mpc-next-action]")) {
        const saved = JSON.parse(sessionStorage.getItem(key) || "null");
        if (saved && Date.now() - saved.at < 3600000 && !url.searchParams.has("release_id")) {
          url.search = saved.search; history.replaceState(null, "", url);
        }
      }
      if (root.querySelector("[data-kob-mpc-next-action]")) sessionStorage.removeItem(key);
    } catch { /* The email link itself remains usable without browser storage. */ }
  }
  if (!root || !root.querySelector("[data-kob-mpc-next-action]") || root.dataset.initialized === "true") return;
  root.dataset.initialized = "true";
  const endpoint = String(root.dataset.endpoint || "").replace(/\/$/, "");
  const refs = {
    email: root.querySelector("[data-kob-mpc-email]"),
    alias: root.querySelector("[data-kob-mpc-alias]"),
    token: root.querySelector("[data-kob-mpc-token]"),
    progress: root.querySelector("[data-kob-mpc-progress]"),
    releaseSelect: root.querySelector("[data-kob-mpc-release-select]"),
    customerLane: root.querySelector("[data-kob-mpc-customer-lane]"),
    supplyLane: root.querySelector("[data-kob-mpc-supply-lane]"),
    checkAnnouncement: root.querySelector("[data-kob-mpc-check-announcement]"),
    announcementCandidate: root.querySelector("[data-kob-mpc-announcement-candidate]"),
    announcementTitle: root.querySelector("[data-kob-mpc-announcement-title]"),
    announcementCopy: root.querySelector("[data-kob-mpc-announcement-copy]"),
    announcementReview: root.querySelector("[data-kob-mpc-announcement-review]"),
    announcementContext: root.querySelector("[data-kob-mpc-announcement-context]"),
    announcementFiles: root.querySelector("[data-kob-mpc-announcement-files]"),
    announcementLines: root.querySelector("[data-kob-mpc-announcement-lines]"),
    announcementReviewed: root.querySelector("[data-kob-mpc-announcement-reviewed]"),
    importAnnouncement: root.querySelector("[data-kob-mpc-import-announcement]"),
    openDuplicate: root.querySelector("[data-kob-mpc-open-duplicate]"),
    nextAction: root.querySelector("[data-kob-mpc-next-action]"),
    refresh: root.querySelector("[data-kob-mpc-refresh]"),
    nextTitle: root.querySelector("[data-kob-mpc-next-title]"),
    nextCopy: root.querySelector("[data-kob-mpc-next-copy]"),
    nextState: root.querySelector("[data-kob-mpc-next-state]"),
    nextBlocker: root.querySelector("[data-kob-mpc-next-blocker]"),
    reviewAnchor: root.querySelector("[data-kob-mpc-review-anchor]"),
    reviewPanel: root.querySelector("[data-kob-mpc-review-panel]"),
    reviewEyebrow: root.querySelector("[data-kob-mpc-review-eyebrow]"),
    reviewTitle: root.querySelector("[data-kob-mpc-review-title]"),
    reviewCopy: root.querySelector("[data-kob-mpc-review-copy]"),
    reviewToolboxSlot: root.querySelector("[data-kob-mpc-review-toolbox-slot]"),
    reviewForm: root.querySelector("[data-kob-mpc-review-form]"),
    reviewLines: root.querySelector("[data-kob-mpc-review-lines]"),
    importMeta: root.querySelector("[data-kob-mpc-import-meta]"),
    operate: root.querySelector("[data-kob-mpc-operate]"),
    publicationStatus: root.querySelector("[data-kob-mpc-publication-status]"),
    publicationTarget: root.querySelector("[data-kob-mpc-publication-target]"),
    publicationTargetDetail: root.querySelector("[data-kob-mpc-publication-target-detail]"),
    accessSource: root.querySelector("[data-kob-mpc-access-source]"),
    previewPublication: root.querySelector("[data-kob-mpc-preview-publication]"),
    publicationNote: root.querySelector("[data-kob-mpc-publication-note]"),
    publish: root.querySelector("[data-kob-mpc-publish]"),
    publicationProgress: root.querySelector("[data-kob-mpc-publication-progress]"),
    resumePublication: root.querySelector("[data-kob-mpc-resume-publication]"),
    customerPage: root.querySelector("[data-kob-mpc-customer-page]"),
    customerPageLink: root.querySelector("[data-kob-mpc-customer-page-link]"),
    copyCustomerUrl: root.querySelector("[data-kob-mpc-copy-customer-url]"),
    publicationTools: root.querySelector("[data-kob-mpc-publication-tools]"),
    orderTools: root.querySelector("[data-kob-mpc-order-tools]"),
    accessPanel: root.querySelector("[data-kob-mpc-access-panel]"),
    accessSummary: root.querySelector("[data-kob-mpc-access-summary]"),
    accessEmail: root.querySelector("[data-kob-mpc-access-email]"),
    accessLookup: root.querySelector("[data-kob-mpc-access-lookup]"),
    accessLookupResult: root.querySelector("[data-kob-mpc-access-lookup-result]"),
    accessAdd: root.querySelector("[data-kob-mpc-access-add]"),
    accessCopySource: root.querySelector("[data-kob-mpc-access-copy-source]"),
    accessToolboxReason: root.querySelector("[data-kob-mpc-access-toolbox-reason]"),
    accessCopyPreview: root.querySelector("[data-kob-mpc-access-copy-preview]"),
    accessCopyResult: root.querySelector("[data-kob-mpc-access-copy-result]"),
    accessCopyApply: root.querySelector("[data-kob-mpc-access-copy-apply]"),
    accessReason: root.querySelector("[data-kob-mpc-access-reason]"),
    accessMemberships: root.querySelector("[data-kob-mpc-access-memberships]"),
    accessSearch: root.querySelector("[data-kob-mpc-access-search]"),
    accessStatus: root.querySelector("[data-kob-mpc-access-status]"),
    accessSearchButton: root.querySelector("[data-kob-mpc-access-search-button]"),
    accessClear: root.querySelector("[data-kob-mpc-access-clear]"),
    accessList: root.querySelector("[data-kob-mpc-access-list]"),
    accessPageStatus: root.querySelector("[data-kob-mpc-access-page-status]"),
    accessMore: root.querySelector("[data-kob-mpc-access-more]"),
    accessAudit: root.querySelector("[data-kob-mpc-access-audit]"),
    accessEvents: root.querySelector("[data-kob-mpc-access-events]"),
    toolbox: root.querySelector("[data-kob-mpc-toolbox]"),
    draftLock: root.querySelector("[data-kob-mpc-draft-lock]"),
    orderMode: root.querySelector("[data-kob-mpc-order-mode]"),
    partners: root.querySelector("[data-kob-mpc-partners]"),
    partnerLines: root.querySelector("[data-kob-mpc-partner-lines]"),
    savePartners: root.querySelector("[data-kob-mpc-save-partners]"),
    previewOrder: root.querySelector("[data-kob-mpc-preview-order]"),
    orderPanel: root.querySelector("[data-kob-mpc-order-panel]"),
    orderLines: root.querySelector("[data-kob-mpc-order-lines]"),
    orderTotal: root.querySelector("[data-kob-mpc-order-total]"),
    orderPreviewTitle: root.querySelector("[data-kob-mpc-order-preview-title]"),
    createDraft: root.querySelector("[data-kob-mpc-create-draft]"),
    monitor: root.querySelector("[data-kob-mpc-monitor]"),
    demandLines: root.querySelector("[data-kob-mpc-demand-lines]"),
    history: root.querySelector("[data-kob-mpc-history]"),
    historyList: root.querySelector("[data-kob-mpc-history-list]"),
    draftModal: root.querySelector("[data-kob-mpc-draft-modal]"),
    draftModalDialog: root.querySelector("[data-kob-mpc-draft-modal] [role='dialog']"),
    draftModalTitle: root.querySelector("[data-kob-mpc-draft-modal-title]"),
    draftModalContent: root.querySelector("[data-kob-mpc-draft-modal-content]"),
    draftModalActions: root.querySelector("[data-kob-mpc-draft-modal-actions]"),
    archivePanel: root.querySelector("[data-kob-mpc-archive-panel]"),
    archiveReason: root.querySelector("[data-kob-mpc-archive-reason]"),
    archiveConfirm: root.querySelector("[data-kob-mpc-archive-confirm]"),
    arrivalHandoff: root.querySelector("[data-kob-mpc-arrival-handoff]"),
    toast: root.querySelector("[data-kob-mpc-toast]"),
    editStatus: root.querySelector("[data-kob-mpc-edit-status]"),
    activeOrders: root.querySelector("[data-kob-mpc-active-orders]"),
    customerGuidance: root.querySelector("[data-kob-mpc-customer-guidance]"),
  };
  const state = {
    releaseId: "", payload: null, orderPreview: null, publicationPreview: null,
    accessPayload: null, accessCustomers: [], accessLookupCustomer: null, accessCopyPlan: null,
    accessListLoaded: false, accessEventsLoaded: false, nextAction: null, workflowStage: 0,
    productPreviews: {}, announcementPreview: null, loading: false, toastTimer: 0,
    reviewPlacement: "", modalDraftId: "", modalReturnFocus: null, deepLinkApplied: false,
    focusSku: "", focusCoverage: false, focusWorkbook: "", focusDraft: "", customerPageUrl: "",
    dirty: new Set(), loadSequence: 0, lastRefreshed: "", orderEdits: {},
    workspace: "overview", supplierTask: "coverage", model: "", modelSearch: "",
    contextRelease: "", resumeContext: null, restored: false,
    pages: {},
  };

  const nextPanel = refs.nextTitle.closest(".kob-mpc__next");
  const supplierAlerts = document.createElement("div");
  supplierAlerts.className = "kob-mpc__notice";
  supplierAlerts.dataset.kobSupplierAlerts = "";
  supplierAlerts.hidden = true;
  root.querySelector("[data-kob-mpc-supplier-guidance]").after(supplierAlerts);

  const workspaceLabels = { overview: "Overview", settings: "Models & settings", customer: "Customer reservations", supplier: "Supplier orders" };
  const taskLabels = { coverage: "Coverage", partners: "Partner requests", order: "Order & email", history: "Order history" };
  const customerWorkspace = root.querySelector(".kob-mpc__lane--customer");
  const supplierWorkspace = root.querySelector(".kob-mpc__lane--supply");
  const resumeDraft = document.createElement("button");
  resumeDraft.type = "button"; resumeDraft.className = "kob-mpc-button";
  resumeDraft.textContent = "Reopen last viewed order";
  resumeDraft.hidden = true;
  root.querySelector("[data-kob-mpc-supplier-guidance]").after(resumeDraft);
  resumeDraft.addEventListener("click", () => { if (draftById(state.resumeContext?.draft)) openDraftModal(state.resumeContext.draft, resumeDraft); });
  const locationLabel = document.createElement("span");
  root.querySelector("[data-kob-mpc-location]").append(locationLabel, refs.refresh, refs.progress.querySelector("a"));
  refs.reviewForm.querySelector(".kob-mpc__bulk-dates").after(root.querySelector(".kob-mpc__model-browser"));
  customerWorkspace.append(refs.accessPanel, refs.toolbox);
  refs.toolbox.querySelector("summary strong").textContent = "Customer access exceptions and audit";
  const supplierViews = {};
  for (const [task, elements] of Object.entries({
    coverage: [root.querySelector(".kob-mpc__coverage")],
    partners: [refs.partners], order: [refs.activeOrders, refs.orderTools, refs.orderPanel], history: [refs.history],
  })) {
    const panel = document.createElement("div");
    panel.dataset.supplierView = task;
    panel.append(...elements);
    supplierWorkspace.append(panel);
    supplierViews[task] = panel;
  }

  function contextKey() {
    return `kob_mpc_context_v1:${encodeURIComponent(refs.email.value)}:${state.releaseId}`;
  }

  function rememberContext() {
    const context = { workspace: state.workspace, task: state.supplierTask, model: state.model, pages: state.pages, draft: state.modalDraftId || state.resumeContext?.draft || "" };
    if (state.workspace !== "overview") state.resumeContext = context;
    try {
      window.localStorage.setItem(contextKey(), JSON.stringify({ ...context, resume: state.resumeContext }));
      const url = new URL(window.location.href);
      url.searchParams.set("workspace", state.workspace);
      url.searchParams.set("task", state.supplierTask);
      url.searchParams.delete("focus");
      url.searchParams.delete("focus_sku");
      if (state.model) url.searchParams.set("model", state.model); else url.searchParams.delete("model");
      window.history.replaceState({}, "", url);
    } catch { /* Navigation remains usable without browser storage. */ }
  }

  function restoreContext() {
    if (state.contextRelease === state.releaseId) return;
    const firstLoad = !state.contextRelease;
    state.contextRelease = state.releaseId;
    let saved = {};
    try { saved = JSON.parse(window.localStorage.getItem(contextKey()) || "{}") || {}; } catch { /* Optional storage. */ }
    const params = new URL(window.location.href).searchParams;
    state.workspace = firstLoad && params.has("workspace") ? params.get("workspace") : saved.workspace || "overview";
    state.supplierTask = firstLoad && params.has("task") ? params.get("task") : saved.task || "coverage";
    state.model = firstLoad && params.has("model") ? params.get("model") : saved.model || "";
    state.modelSearch = "";
    state.pages = saved.pages && typeof saved.pages === "object" ? saved.pages : {};
    root.querySelector("[data-kob-mpc-model-search]").value = "";
    state.resumeContext = saved.resume || (saved.workspace && saved.workspace !== "overview" ? saved : null);
    state.restored = Boolean(saved.workspace || (firstLoad && params.has("workspace")));
    if (firstLoad && state.focusCoverage) { state.workspace = "supplier"; state.supplierTask = "coverage"; }
    else { state.focusCoverage = false; state.focusSku = ""; }
  }

  function selectWorkspace(workspace, { task = state.supplierTask, remember = true } = {}) {
    state.workspace = workspaceLabels[workspace] ? workspace : "overview";
    state.supplierTask = taskLabels[task] ? task : "coverage";
    const available = Boolean(state.payload?.workflow && state.payload?.release);
    if (!available) state.workspace = "overview";
    const overview = state.workspace === "overview";
    refs.reviewPanel.hidden = !available || state.workspace !== "settings";
    if (!refs.reviewPanel.hidden) refs.reviewPanel.open = true;
    refs.operate.hidden = !available || !["customer", "supplier"].includes(state.workspace);
    customerWorkspace.hidden = state.workspace !== "customer";
    supplierWorkspace.hidden = state.workspace !== "supplier";
    nextPanel.hidden = !overview;
    root.querySelector(".kob-mpc__summary").hidden = !overview;
    root.querySelector(".kob-mpc__causal-note").hidden = !overview;
    root.querySelector("[data-kob-mpc-flow]").hidden = !available || !overview;
    refs.arrivalHandoff.hidden = !available || !overview;
    for (const [key, panel] of Object.entries(supplierViews)) panel.hidden = key !== state.supplierTask;
    if (state.supplierTask === "history") refs.history.open = true;
    root.querySelectorAll("[data-kob-mpc-workspace]").forEach((button) => {
      if (button.closest("[data-kob-mpc-progress]")) {
        button.setAttribute("aria-pressed", String(button.dataset.kobMpcWorkspace === state.workspace));
        button.disabled = !available && button.dataset.kobMpcWorkspace !== "overview";
      }
    });
    root.querySelectorAll("[data-kob-mpc-supplier-task]").forEach((button) => button.setAttribute("aria-pressed", String(button.dataset.kobMpcSupplierTask === state.supplierTask)));
    const label = `${workspaceLabels[state.workspace]}${state.workspace === "supplier" ? ` / ${taskLabels[state.supplierTask]}` : ""}`;
    locationLabel.textContent = `${state.restored ? "Resumed · " : ""}${label}${state.workspace === "settings" && state.model ? ` / ${state.model}` : ""}`;
    state.restored = false;
    root.querySelector("[data-kob-mpc-supplier-guidance]").textContent = {
      coverage: "Compare paid and partner demand with verified SENT coverage. An unsent Draft does not cover demand. Use a highlighted row to review the existing Draft or prepare the gap.",
      partners: "Save Kai and Dai requests before recalculating procurement. Actual stock allocation and additional partner units are handled in Arrivals & Balances.",
      order: "Review quantities → create a Draft → review and send in Gmail → verify SENT here. Early orders can happen before customer opening or the reservation deadline.",
      history: "Open a saved order to inspect its quantities, email and verification status. Completed orders remain available here.",
    }[state.supplierTask];
    if (remember) rememberContext();
    if (remember) locationLabel.parentElement.scrollIntoView({ behavior: "auto", block: "start" });
    resumeDraft.hidden = !draftById(state.resumeContext?.draft);
    const resume = state.resumeContext;
    root.querySelector("[data-kob-mpc-resume]").hidden = !overview || !resume;
    root.querySelector("[data-kob-mpc-resume-copy]").textContent = resume ? `Last work: ${workspaceLabels[resume.workspace] || "Overview"}${resume.workspace === "supplier" ? ` / ${taskLabels[resume.task] || "Coverage"}` : ""}${resume.workspace === "settings" && resume.model ? ` / ${resume.model}` : ""}. Location only; unsaved edits are not restored.` : "";
  }

  function revealTask(target) {
    if (refs.reviewPanel.contains(target) || target === refs.reviewPanel) selectWorkspace("settings");
    else if (customerWorkspace.contains(target)) selectWorkspace("customer");
    else {
      const task = Object.keys(supplierViews).find((key) => supplierViews[key].contains(target));
      if (task) selectWorkspace("supplier", { task });
    }
  }

  function renderModelPicker(focusCode = "") {
    const allRows = [...refs.reviewLines.querySelectorAll("tr[data-code]")];
    const rows = allRows.filter((row) => `${row.dataset.code} ${row.querySelector('[data-field="product_title"]').value}`.toLowerCase().includes(state.modelSearch.toLowerCase()));
    const pages = Math.max(1, Math.ceil(rows.length / 5));
    const focusIndex = rows.findIndex((row) => row.dataset.code === focusCode);
    if (focusIndex >= 0) state.pages.settings = Math.floor(focusIndex / 5);
    state.pages.settings = Math.max(0, Math.min(Number(state.pages.settings || 0), pages - 1));
    const start = state.pages.settings * 5;
    const visible = rows.slice(start, start + 5);
    if (!visible.some((row) => row.dataset.code === state.model)) state.model = visible[0]?.dataset.code || "";
    allRows.forEach((row) => { row.hidden = !visible.includes(row); row.classList.toggle("is-current-model", row.dataset.code === state.model); });
    root.querySelector("[data-kob-mpc-model-position]").textContent = rows.length ? `${start + 1}–${Math.min(start + 5, rows.length)} of ${rows.length} models · Page ${state.pages.settings + 1} / ${pages}` : "No matching models";
    root.querySelector("[data-kob-mpc-model-prev]").disabled = start === 0;
    root.querySelector("[data-kob-mpc-model-next]").disabled = state.pages.settings >= pages - 1;
    if (state.workspace === "settings") locationLabel.textContent = `${workspaceLabels.settings}${state.model ? ` / ${state.model}` : ""}`;
  }

  function updateModelRow(row) {
    const limited = Number(row.querySelector('[data-field="limited_pcs"]').value || 0);
    const suggested = limited > 0 ? Math.ceil(limited * .05) : 20;
    const cap = Number(row.querySelector('[data-field="preorder_cap"]').value);
    row.querySelector("[data-suggested-cap]").textContent = number(suggested);
    row.querySelector("[data-cap-basis]").textContent = limited > 0 ? `${number(limited)} × 5%, rounded up` : "No stated limit";
    row.querySelector("[data-cap-status]").textContent = cap === suggested ? "Matches suggestion" : "Manual adjustment";
    row.querySelector("[data-use-suggested-cap]").disabled = cap === suggested;
    row.querySelector("[data-secure-target]").hidden = row.querySelector('[data-field="supplier_priority"]').value !== "secure_early";
    row.querySelector("[data-model-name]").textContent = row.querySelector('[data-field="product_title"]').value;
  }

  function paginateRows(container, key, focusCode = "") {
    const rows = [...container.querySelectorAll(":scope > [data-code]")];
    let toolbar = container.parentElement.querySelector(`[data-pages="${key}"]`);
    if (!toolbar) {
      toolbar = document.createElement("div"); toolbar.className = "kob-mpc__pagination"; toolbar.dataset.pages = key;
      container.after(toolbar);
      toolbar.addEventListener("click", (event) => {
        const button = event.target.closest("[data-page-offset]");
        if (!button) return;
        state.pages[key] = Number(state.pages[key] || 0) + Number(button.dataset.pageOffset);
        paginateRows(container, key); rememberContext();
      });
    }
    const pageCount = Math.max(1, Math.ceil(rows.length / 5));
    const focusIndex = rows.findIndex((row) => row.dataset.code === focusCode);
    const requestedPage = focusIndex >= 0 ? Math.floor(focusIndex / 5) : Number(state.pages[key]) || 0;
    const page = Math.max(0, Math.min(pageCount - 1, requestedPage)); state.pages[key] = page;
    rows.forEach((row, index) => { row.hidden = Math.floor(index / 5) !== page; });
    toolbar.hidden = rows.length <= 5;
    toolbar.innerHTML = `<button type="button" class="kob-mpc-button" data-page-offset="-1"${page === 0 ? " disabled" : ""}>Previous models</button><span>${rows.length ? page * 5 + 1 : 0}–${Math.min(rows.length, (page + 1) * 5)} of ${rows.length}</span><button type="button" class="kob-mpc-button" data-page-offset="1"${page === pageCount - 1 ? " disabled" : ""}>Next models</button>`;
  }

  function renderFlow(payload) {
    const reviewed = payload.workflow?.import_status === "reviewed";
    const published = payload.workflow?.publication_status === "published";
    const active = (payload.order_drafts || []).filter((draft) => ["preparing", "replacing", "draft_created", "recovery_required"].includes(draft.status));
    const gap = Number(payload.totals?.coverage_gap_qty ?? payload.totals?.addon_needed_qty ?? 0);
    const changed = published && Number(payload.workflow.review_revision || 0) !== Number(payload.workflow.published_review_revision || 0);
    const cards = [
      ["settings", "1 · Announcement & review", reviewed ? "Settings saved" : "Product review required", "Review dates, caps and early-order targets"],
      ["customer", "2A · Customer reservations", changed ? "Saved changes need publication review" : refs.customerLane.textContent, published ? "Review customer page and access" : "Review opening when ready"],
      ["supplier", "2B · Supplier procurement", active.length ? `${active.length} active Draft · not SENT` : `${gap} units need coverage`, active.length ? "Continue the existing email" : gap ? "Review early targets and demand" : "Monitor demand; no order needed now"],
    ];
    root.querySelector("[data-kob-mpc-flow]").innerHTML = cards.map(([workspace, title, status, action]) => `<button type="button" class="kob-mpc__flow-card" data-flow-workspace="${workspace}"${workspace === "supplier" ? ` data-flow-task="${active.length ? "order" : "coverage"}"` : ""}><strong>${title}</strong><span>${escapeHtml(status)}</span><small>${action}</small></button>`).join("") + '<a class="kob-mpc__flow-card" href="/pages/kob-makeup-arrival-control"><strong>3 · Arrival & allocation</strong><span>Continue when the invoice arrives</span><small>Customers first, then partner allocation and balances</small></a>';
  }

  function editingNotice(message = "") {
    if (refs.editStatus) refs.editStatus.textContent = message || (state.dirty.size
      ? "Unsaved changes. Automatic refresh is paused until you save or discard them."
      : (state.lastRefreshed ? `Last refreshed ${state.lastRefreshed}.` : ""));
    root.querySelectorAll("[data-kob-mpc-progress] [data-kob-mpc-workspace]").forEach((button) => {
      const workspace = button.dataset.kobMpcWorkspace;
      const dirty = workspace === "settings" ? state.dirty.has("settings") : workspace === "supplier" && (state.dirty.has("partners") || state.dirty.has("order"));
      button.textContent = `${workspaceLabels[workspace]}${dirty ? " · Unsaved" : ""}`;
    });
  }

  function invalidatePlans() {
    state.orderPreview = null;
    state.publicationPreview = null;
    refs.orderPanel.hidden = true;
    refs.publish.disabled = true;
    refs.createDraft.disabled = true;
    state.dirty.delete("order");
  }

  function markDirty(area) {
    state.dirty.add(area);
    if (area !== "order") invalidatePlans();
    refs.previewOrder.disabled = state.dirty.has("settings") || state.dirty.has("partners") || state.payload?.workflow?.import_status !== "reviewed";
    refs.previewPublication.disabled = state.dirty.has("settings") || state.payload?.workflow?.import_status !== "reviewed";
    editingNotice();
  }

  function discardEdits() {
    if (state.dirty.size && !window.confirm("Discard unsaved changes in this release? Cancel to stay here and save them first.")) return false;
    state.dirty.clear();
    state.orderEdits = {};
    invalidatePlans();
    return true;
  }

  function resetReleaseContext() {
    invalidatePlans();
    state.accessLookupCustomer = null;
    state.accessCopyPlan = null;
    state.orderEdits = {};
    refs.accessAdd.disabled = true;
    refs.accessCopyApply.disabled = true;
    refs.accessSource.value = "";
    refs.accessEmail.value = "";
    refs.accessCopySource.value = "";
    refs.accessLookupResult.textContent = "Search by exact account email.";
    refs.accessCopyResult.textContent = "Preview an add-only copy before applying.";
    refs.publicationNote.textContent = "Review this release's products, dates and customer access before publishing.";
    closeDraftModal();
  }

  root.addEventListener("click", (event) => {
    if (state.loading) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  root.addEventListener("input", (event) => {
    if (refs.reviewForm.contains(event.target) && !event.target.matches("[data-kob-mpc-bulk-supplier], [data-kob-mpc-bulk-close], [data-bulk-model], [data-kob-mpc-model-search]")) markDirty("settings");
    else if (event.target === refs.accessSource) { state.publicationPreview = null; refs.publish.disabled = true; }
    else if (refs.orderLines.contains(event.target)) markDirty("order");
  });
  refs.reviewForm.addEventListener("change", (event) => {
    if (event.target.matches("[data-field]")) markDirty("settings");
  });
  window.addEventListener("beforeunload", (event) => {
    if (state.dirty.size) { event.preventDefault(); event.returnValue = ""; }
  });

  try {
    const params = new URL(window.location.href).searchParams;
    state.focusSku = String(params.get("focus_sku") || "").trim().toUpperCase();
    state.focusCoverage = params.get("focus") === "coverage";
    state.focusWorkbook = String(params.get("focus_workbook") || "");
    state.focusDraft = String(params.get("order_draft_id") || "");
  } catch { /* Embedded previews may not expose a page URL. */ }

  function authUrl(path) {
    const url = new URL(`${endpoint}${path}`);
    const values = { email: refs.email?.value || "", partner_alias: refs.alias?.value || "", partner_token: refs.token?.value || "" };
    Object.entries(values).forEach(([key, value]) => { if (value) url.searchParams.set(key, value); });
    return url;
  }

  async function api(path, options = {}) {
    const url = authUrl(path);
    const response = await fetch(url.toString(), {
      ...options,
      headers: { "content-type": "application/json", ...(options.headers || {}) },
    });
    let payload;
    try { payload = await response.json(); } catch { payload = { ok: false, error: `HTTP ${response.status}` }; }
    if (!response.ok || !payload.ok) {
      const messages = {
        publication_job_in_progress: "Finish the saved publication before changing model settings or customer access.",
        publication_job_busy: "Another publication request is still running. Wait briefly, then resume.",
        publication_inventory_recovery_required: "Inventory changed during an interrupted setup. Publication is paused for an inventory check; no stock was reset.",
        publication_creation_recovery_required: "The product creation result is uncertain. Resume after checking Shopify; no duplicate was created.",
        review_changed_refresh_preview: "The reviewed data changed. Review the latest plan before continuing.",
        release_review_changed: "Another save changed this release. Your edits are kept; refresh and compare before saving again.",
        release_review_version_required: "Refresh the page to load the current release version.",
        model_close_after_supplier_deadline: "A model's customer close is after its supplier deadline. Check its JST dates.",
        supplier_sent_quantities_mismatch: "The sent workbook quantities do not match this order. Nothing was recorded. Check the actual sent attachments.",
        supplier_sent_attachment_invalid: "The sent order workbook could not be verified. Nothing was recorded.",
        preorder_english_review_stale: "The English-title review expired or the source changed. Check the announcement again before importing.",
        preorder_english_image_missing: "A matching specification image is missing. English colours cannot be verified; nothing was imported.",
        preorder_english_code_mismatch: "A specification image could not be matched to its model code. Nothing was imported.",
        preorder_english_text_missing: "Printed English model or body-colour text could not be read. Nothing was imported.",
        preorder_english_ocr_not_configured: "English text extraction is not configured. Nothing was imported.",
        preorder_english_ocr_unavailable: "English text extraction timed out or is unavailable. Retry the announcement check.",
        preorder_english_ocr_failed: "English text extraction failed. Retry the announcement check.",
        preorder_english_ocr_invalid_response: "English text extraction returned an incomplete result. Retry the announcement check.",
        supplier_sent_message_ambiguous: "More than one sent message matches this order. Resolve the matching email before recording.",
        supplier_order_not_sent_yet: "No matching sent order was found. Check the Gmail account, recipients, subject and sending time.",
      };
      const message = messages[payload.error] || payload.detail || payload.error || `HTTP ${response.status}`;
      editingNotice(message);
      throw new Error(message);
    }
    return payload;
  }

  function setLoading(value) {
    state.loading = value;
    root.classList.toggle("is-loading", value);
    refs.nextAction.disabled = value;
    refs.refresh.disabled = value;
    if (refs.checkAnnouncement) refs.checkAnnouncement.disabled = value;
    if (refs.importAnnouncement) refs.importAnnouncement.disabled = value || !canImportAnnouncement();
    if (refs.announcementReviewed) refs.announcementReviewed.disabled = value || !hasAnnouncementLines();
    if (refs.openDuplicate) refs.openDuplicate.disabled = value;
    if (refs.releaseSelect) refs.releaseSelect.disabled = value;
    if (value) {
      state.busyInputs = [...root.querySelectorAll("input:not([type=hidden]), select, textarea")].map((input) => [input, input.disabled]);
      for (const [input] of state.busyInputs) input.disabled = true;
    } else {
      for (const [input, disabled] of state.busyInputs || []) if (input.isConnected) input.disabled = disabled;
      state.busyInputs = [];
      refs.releaseSelect.disabled = false;
      refs.announcementReviewed.disabled = !hasAnnouncementLines();
    }
  }

  function toast(message) {
    if (!refs.toast) return;
    refs.toast.textContent = message;
    refs.toast.classList.add("is-visible");
    clearTimeout(state.toastTimer);
    state.toastTimer = setTimeout(() => refs.toast.classList.remove("is-visible"), 4800);
  }

  function publishedCustomerPageUrl(payload) {
    if (payload?.workflow?.publication_status !== "published") return "";
    const handle = String(payload.workflow.published_page_handle || "").trim();
    if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle)) return "";
    try {
      return new URL(`/pages/${handle}`, root.dataset.storefrontUrl || window.location.origin).toString();
    } catch { return ""; }
  }

  async function copyText(value) {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return;
    }
    const field = document.createElement("textarea");
    field.value = value;
    field.setAttribute("readonly", "");
    field.style.position = "fixed";
    field.style.opacity = "0";
    document.body.append(field);
    field.select();
    const copied = document.execCommand("copy");
    field.remove();
    if (!copied) throw new Error("copy_not_supported");
  }

  function detailTrigger(label, content, options = {}) {
    const className = ["kob-mpc__detail-trigger", options.className || ""].filter(Boolean).join(" ");
    const productCode = options.productCode ? ` data-kob-mpc-product-code="${escapeHtml(options.productCode)}"` : "";
    return `<button class="${className}" type="button" data-kob-mpc-detail-trigger${productCode} aria-expanded="false" aria-label="${escapeHtml(options.ariaLabel || `${label} details`)}">
      ${escapeHtml(label)}
      <span class="kob-mpc__detail-popover${options.wide ? " kob-mpc__detail-popover--wide" : ""}">${content}</span>
    </button>`;
  }

  function productDetail(code, fallbackTitle = "") {
    const key = String(code || "").trim().toUpperCase();
    const line = (state.payload?.lines || []).find((row) => String(row.variant_code || "").trim().toUpperCase() === key) || {};
    const demand = (state.payload?.supplier_summary || []).find((row) => String(row.variant_code || "").trim().toUpperCase() === key) || {};
    const preview = (state.orderPreview?.plan || []).find((row) => String(row.variant_code || "").trim().toUpperCase() === key) || {};
    const hydrated = state.productPreviews[key] || {};
    return {
      code: key,
      title: hydrated.title || line.product_title || demand.product_title || preview.product_title || fallbackTitle || "Product name unavailable",
      imageUrl: line.image_url || demand.image_url || preview.image_url || hydrated.image_url || line.payload?.image_url || "",
    };
  }

  function replaceProductPreview(code, next) {
    const key = String(code || "").trim().toUpperCase();
    const previous = state.productPreviews[key] || {};
    if (previous.object_url && previous.image_url && previous.image_url !== next.image_url) {
      URL.revokeObjectURL(previous.image_url);
    }
    state.productPreviews[key] = { ...previous, ...next };
  }

  function clearProductPreviews() {
    Object.values(state.productPreviews).forEach((preview) => {
      if (preview?.object_url && preview.image_url) URL.revokeObjectURL(preview.image_url);
    });
    state.productPreviews = {};
  }

  async function fetchPrivateProductImage(code, releaseId) {
    if (!releaseId || typeof URL.createObjectURL !== "function") return "";
    const imageUrl = authUrl("/makeup-preorder-operations/product-image");
    imageUrl.searchParams.set("release_id", releaseId);
    imageUrl.searchParams.set("variant_code", code);
    const response = await fetch(imageUrl.toString(), {
      cache: "no-store",
      headers: { accept: "image/avif,image/webp,image/*" },
      referrerPolicy: "no-referrer",
    });
    if (!response.ok || !String(response.headers.get("content-type") || "").toLowerCase().startsWith("image/")) return "";
    const blob = await response.blob();
    if (!blob.size) return "";
    const objectUrl = URL.createObjectURL(blob);
    if (state.releaseId !== releaseId) {
      URL.revokeObjectURL(objectUrl);
      return "";
    }
    return objectUrl;
  }

  function productPreviewContent(detail) {
    const thumbnail = detail.imageUrl
      ? `<img src="${escapeHtml(detail.imageUrl)}" alt="" loading="lazy">`
      : '<span class="kob-mpc__product-thumb-placeholder" aria-hidden="true"></span>';
    return `<span class="kob-mpc__product-preview"><span class="kob-mpc__product-thumb">${thumbnail}</span><strong>${escapeHtml(detail.title)}</strong></span>`;
  }

  function renderProductCode(code, fallbackTitle = "", secondary = "") {
    const detail = productDetail(code, fallbackTitle);
    return `${detailTrigger(detail.code, productPreviewContent(detail), { className: "kob-mpc__product-code", ariaLabel: `${detail.code} product preview`, productCode: detail.code })}${secondary ? `<small>${escapeHtml(secondary)}</small>` : ""}`;
  }

  async function hydrateProductPreviews(codes) {
    const releaseId = state.releaseId;
    const canSearchStorefront = /^https?:$/.test(window.location.protocol);
    const unique = [...new Set(codes.map((code) => String(code || "").trim().toUpperCase()).filter(Boolean))]
      .filter((code) => !state.productPreviews[code]?.loaded && !state.productPreviews[code]?.loading);
    await Promise.all(unique.map(async (code) => {
      replaceProductPreview(code, { loading: true });
      const direct = productDetail(code);
      if (direct.imageUrl && !state.productPreviews[code]?.object_url) {
        replaceProductPreview(code, { loaded: true, loading: false });
        return;
      }

      let title = "";
      let storefrontImageUrl = "";
      if (canSearchStorefront) {
        try {
          const query = new URLSearchParams({ q: code, "resources[type]": "product", "resources[limit]": "4" });
          const response = await fetch(`/search/suggest.json?${query.toString()}`, { headers: { accept: "application/json" } });
          if (response.ok) {
            const payload = await response.json();
            const products = payload?.resources?.results?.products || [];
            const product = products.find((item) => String(item.title || "").toUpperCase().includes(code)) || products[0];
            if (product) {
              const imageUrl = product.featured_image?.url || product.featured_image || product.image || "";
              title = product.title || "";
              storefrontImageUrl = typeof imageUrl === "string" ? imageUrl : imageUrl?.url || "";
            }
          }
        } catch {
          // A private imported preview remains available when storefront search is unavailable.
        }
      }
      if (state.releaseId !== releaseId) return;
      if (storefrontImageUrl) {
        replaceProductPreview(code, { loaded: true, loading: false, object_url: false, title, image_url: storefrontImageUrl });
        return;
      }

      try {
        const objectUrl = await fetchPrivateProductImage(code, releaseId);
        if (objectUrl) {
          replaceProductPreview(code, { loaded: true, loading: false, object_url: true, title, image_url: objectUrl });
          return;
        }
      } catch {
        // Product previews are optional; operational controls remain usable without them.
      }
      if (state.releaseId === releaseId) replaceProductPreview(code, { loaded: true, loading: false, object_url: false, title, image_url: "" });
    }));
    if (state.releaseId !== releaseId) return;
    root.querySelectorAll("[data-kob-mpc-product-code]").forEach((trigger) => {
      const detail = productDetail(trigger.dataset.kobMpcProductCode || "");
      const popover = trigger.querySelector(".kob-mpc__detail-popover");
      if (popover) popover.innerHTML = productPreviewContent(detail);
    });
    refs.reviewLines.querySelectorAll("[data-model-thumbnail]").forEach((thumbnail) => {
      thumbnail.innerHTML = modelThumbnail(thumbnail.dataset.modelThumbnail);
    });
  }

  function modelThumbnail(code) {
    const url = productDetail(code).imageUrl;
    return url ? `<img src="${escapeHtml(url)}" alt="${escapeHtml(code)} model thumbnail" loading="lazy">` : '<span class="kob-mpc__product-thumb-placeholder" aria-label="Image unavailable"></span>';
  }

  function closeDetailTriggers(except = null) {
    root.querySelectorAll("[data-kob-mpc-detail-trigger].is-open").forEach((trigger) => {
      if (trigger === except) return;
      trigger.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
    });
  }

  function positionDetail(trigger) {
    const popover = trigger?.querySelector(".kob-mpc__detail-popover");
    if (!popover || window.matchMedia("(max-width: 749px)").matches) return;
    popover.style.left = "12px";
    popover.style.top = "12px";
    const triggerRect = trigger.getBoundingClientRect();
    const popoverRect = popover.getBoundingClientRect();
    const left = Math.max(12, Math.min(triggerRect.left, window.innerWidth - popoverRect.width - 12));
    let top = triggerRect.bottom + 8;
    if (top + popoverRect.height > window.innerHeight - 12) top = triggerRect.top - popoverRect.height - 8;
    popover.style.left = `${left}px`;
    popover.style.top = `${Math.max(12, top)}px`;
  }

  function draftById(orderDraftId) {
    return (state.payload?.order_drafts || []).find((row) => row.order_draft_id === orderDraftId) || null;
  }

  function closeDraftModal() {
    if (!refs.draftModal || refs.draftModal.hidden) return;
    refs.draftModal.hidden = true;
    refs.archivePanel.hidden = true;
    refs.archiveReason.value = "";
    document.body.classList.remove("kob-mpc-modal-open");
    const returnFocus = state.modalReturnFocus;
    state.modalDraftId = "";
    state.modalReturnFocus = null;
    returnFocus?.focus?.();
  }

  function openDraftModal(orderDraftId, returnFocus = null) {
    const row = draftById(orderDraftId);
    if (!row || !refs.draftModal) return;
    const positivePlan = (row.plan || []).filter((line) => Number(line.planned_qty || 0) > 0);
    const quantity = positivePlan.reduce((sum, line) => sum + Number(line.planned_qty || 0), 0);
    const archiveable = ["draft_created", "recovery_required"].includes(row.status);
    state.modalDraftId = orderDraftId;
    rememberContext();
    state.modalReturnFocus = returnFocus;
    refs.draftModalTitle.textContent = `${row.mode === "add-on" ? "Add-on" : "Initial"} order · ${number(quantity)} units`;
    const plan = positivePlan.length
      ? `<span class="kob-mpc__order-detail-lines">${positivePlan.map((line) => `<span><b>${escapeHtml(line.variant_code)}</b><span>${escapeHtml(line.product_title || productDetail(line.variant_code).title)}</span><strong>&times; ${number(line.planned_qty)}</strong></span>`).join("")}</span>`
      : '<p>No positive quantities were saved in this record.</p>';
    refs.draftModalContent.innerHTML = `
      <div class="kob-mpc__modal-summary">
        <span><small>Status</small><strong>${escapeHtml(statusLabel(row.status))}</strong></span>
        <span><small>Created</small><strong>${escapeHtml(formatDate(row.created_at))}</strong></span>
        <span><small>Demand</small><strong>${row.stale ? "Changed since Draft" : "Matches saved snapshot"}</strong></span>
      </div>
      ${row.email_subject ? `<p class="kob-mpc__modal-subject"><small>Gmail subject</small><br>${escapeHtml(row.email_subject)}</p>` : ""}
      ${row.status === "archived" ? `<p class="kob-mpc__notice"><strong>Archived from current decisions.</strong><br>${escapeHtml(row.archive_reason || "No archive reason recorded.")} This did not delete the Gmail Draft.</p>` : ""}
      ${archiveable ? '<p class="kob-mpc__notice">Saved order quantities stay fixed. To change them, first check whether the email was sent. For an unsent email, remove the draft in Gmail, archive this record, then review a new order. A sent order must be verified before preparing an add-on.</p>' : ""}
      ${plan}`;
    refs.draftModalActions.innerHTML = `${row.email_subject ? `<a class="kob-mpc-button" href="https://mail.google.com/mail/#search/${encodeURIComponent(`in:anywhere subject:"${row.email_subject}"`)}" target="_blank" rel="noopener">Find email in Gmail</a>` : ""}${row.status === "draft_created" ? '<button class="kob-mpc-button" type="button" data-modal-replace-draft>Refresh email with saved quantities</button>' : ""}${archiveable ? '<button class="kob-mpc-button kob-mpc-button--primary" type="button" data-modal-reconcile>Check Gmail sent status</button><button class="kob-mpc-button kob-mpc-button--danger" type="button" data-modal-show-archive>Archive Draft record</button>' : ""}<button class="kob-mpc-button" type="button" data-kob-mpc-modal-close>Close</button>`;
    refs.archivePanel.hidden = true;
    refs.archiveReason.value = "";
    refs.draftModal.hidden = false;
    document.body.classList.add("kob-mpc-modal-open");
    refs.draftModalDialog.focus();
  }

  function applyDeepLinkFocus() {
    if (state.deepLinkApplied || !state.focusCoverage || !state.focusSku) return;
    const row = refs.demandLines.querySelector(`[data-code="${CSS.escape(state.focusSku)}"]`);
    if (!row) return;
    state.deepLinkApplied = true;
    row.classList.add("is-focused");
    selectWorkspace("supplier", { task: "coverage" });
    paginateRows(refs.demandLines, "coverage", state.focusSku);
    rememberContext();
    row.scrollIntoView({ behavior: "smooth", block: "center" });
    const gap = Number((state.payload?.supplier_summary || []).find((item) => String(item.variant_code || "").toUpperCase() === state.focusSku)?.coverage_gap_qty || 0);
    toast(gap > 0 ? `${state.focusSku} needs ${gap} more unit${gap === 1 ? "" : "s"} of verified SENT coverage.` : `${state.focusSku} no longer has a coverage gap.`);
    if (state.focusWorkbook) {
      const codes = new Set((state.payload?.lines || []).filter(line => {
        const p = line.payload || {};
        return [p.source_xlsx_hash, p.source_xlsx_object_key, p.source_file_name, p.release_code].includes(state.focusWorkbook);
      }).map(line => line.variant_code));
      refs.demandLines.querySelectorAll("[data-code]").forEach(node => { if (codes.has(node.dataset.code)) node.classList.add("is-focused"); });
    }
    const draft = draftById(state.focusDraft);
    if (draft && ["preparing", "replacing", "draft_created", "recovery_required"].includes(draft.status)) {
      selectWorkspace("supplier", { task: "order" });
      openDraftModal(draft.order_draft_id);
    }
  }

  async function load(releaseId = state.releaseId, options = {}) {
    if (state.dirty.size) { editingNotice(); return; }
    const sequence = ++state.loadSequence;
    const url = new URL(authUrl("/makeup-preorder-operations/admin.json"));
    if (releaseId) url.searchParams.set("release_id", releaseId);
    const response = await fetch(url.toString());
    const payload = await response.json().catch(() => ({ ok: false, error: `HTTP ${response.status}` }));
    if (!response.ok || !payload.ok) throw new Error(payload.detail || payload.error || `HTTP ${response.status}`);
    if (sequence !== state.loadSequence || state.dirty.size) return;
    const previousReleaseId = state.releaseId;
    state.payload = payload;
    state.releaseId = payload.release_id || "";
    if (state.releaseId) {
      try {
        window.localStorage.setItem("kob_makeup_preorder_release", state.releaseId);
        const pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set("release_id", state.releaseId);
        window.history.replaceState({}, "", pageUrl);
      } catch { /* URL/local storage is optional in embedded previews. */ }
    }
    if (previousReleaseId !== state.releaseId) {
      resetReleaseContext();
      clearProductPreviews();
      state.accessCustomers = [];
      state.accessListLoaded = false;
      state.accessEventsLoaded = false;
      if (refs.accessMemberships) refs.accessMemberships.open = false;
      if (refs.accessAudit) refs.accessAudit.open = false;
    }
    restoreContext();
    render(payload);
    state.lastRefreshed = new Date().toLocaleTimeString("en-GB", { hour12: false });
    editingNotice();
    window.setTimeout(applyDeepLinkFocus, 0);
    supplierAlerts.hidden = true;
    api(`/makeup-preorder-operations/supplier-alerts.json?release_id=${encodeURIComponent(state.releaseId)}`).then(result => {
      if (sequence !== state.loadSequence || state.releaseId !== result.release_id) return;
      const alerts = (result.alerts || []).filter(alert => alert.gap > 0);
      const health = result.health || {};
      const warnings = [health.enabled === 0 ? "Supplier reminder emails are paused." : "", health.last_error || "", health.delivery_reviews > 0 ? `${number(health.delivery_reviews)} email deliveries need Gmail SENT verification. Check coverage even if no reminder has arrived.` : ""].filter(Boolean);
      supplierAlerts.hidden = !alerts.length && !warnings.length;
      supplierAlerts.innerHTML = `<strong>Supplier reminders</strong>${warnings.map(warning => `<p>${escapeHtml(warning)}</p>`).join("")}${alerts.map(alert => `<p><a href="${escapeHtml(alert.url)}">${escapeHtml(alert.workbook)} · ${number(alert.gap)} short</a> — ${escapeHtml(alert.delivery_status === "sent" ? "Reminder sent" : alert.delivery_status === "not_due" ? "Monitoring" : alert.delivery_status === "needs_review" ? "Email delivery needs review" : "Reminder pending")} ${alert.last_error ? `<br>${escapeHtml(alert.last_error)}` : ""}</p>`).join("")}`;
    }).catch(() => {
      if (sequence !== state.loadSequence) return;
      supplierAlerts.hidden = false; supplierAlerts.textContent = "Supplier reminder status unavailable. Check coverage before the deadline.";
    });
    if (state.releaseId) await loadAccessSummary(state.releaseId);
    if (!options.silent) return payload;
    return payload;
  }

  async function loadAccessSummary(releaseId) {
    if (!refs.accessPanel || !releaseId) return;
    const access = await api(`/makeup-preorder-operations/access-customers?release_id=${encodeURIComponent(releaseId)}&limit=1`);
    if (releaseId !== state.releaseId) return;
    state.accessPayload = access;
    renderAccessSummary(access.summary || {});
  }

  function renderAccessSummary(summary) {
    refs.accessSummary.textContent = `${Number(summary.active || 0)} active / ${Number(summary.revoked || 0)} revoked`;
  }

  async function loadAccessCustomers({ reset = false } = {}) {
    if (!state.releaseId || !refs.accessMemberships?.open) return;
    const releaseId = state.releaseId;
    const query = String(refs.accessSearch?.value || "").trim();
    if (query && refs.accessSearch && !refs.accessSearch.checkValidity()) {
      refs.accessSearch.reportValidity();
      return;
    }
    const params = new URLSearchParams({ release_id: state.releaseId, limit: "20", offset: String(reset ? 0 : state.accessCustomers.length) });
    const status = String(refs.accessStatus?.value || "");
    if (status) params.set("status", status);
    if (query) params.set("q", query);
    if (reset) {
      state.accessCustomers = [];
      refs.accessList.innerHTML = '<tr><td colspan="6">Loading masked memberships...</td></tr>';
    }
    const payload = await api(`/makeup-preorder-operations/access-customers?${params.toString()}`);
    if (releaseId !== state.releaseId) return;
    state.accessPayload = payload;
    state.accessListLoaded = true;
    state.accessCustomers = reset ? (payload.customers || []) : [...state.accessCustomers, ...(payload.customers || [])];
    renderAccessSummary(payload.summary || {});
    renderAccessCustomers({ ...payload, customers: state.accessCustomers });
  }

  async function loadAccessEvents({ force = false } = {}) {
    if (!state.releaseId || !refs.accessAudit?.open || (state.accessEventsLoaded && !force)) return;
    const releaseId = state.releaseId;
    refs.accessEvents.innerHTML = "<p>Loading masked access events...</p>";
    const audit = await api(`/makeup-preorder-operations/access-events?release_id=${encodeURIComponent(state.releaseId)}&limit=50`);
    if (releaseId !== state.releaseId) return;
    state.accessEventsLoaded = true;
    renderAccessEvents(audit.events || []);
  }

  async function refreshExpandedAccess() {
    await loadAccessSummary(state.releaseId);
    if (refs.accessMemberships?.open) await loadAccessCustomers({ reset: true });
    if (refs.accessAudit?.open) await loadAccessEvents({ force: true });
  }

  function renderAccessCustomers(payload) {
    const customers = payload.customers || [];
    const total = Number(payload.pagination?.total || customers.length);
    if (refs.accessPageStatus) refs.accessPageStatus.textContent = `Showing ${customers.length} of ${total} masked membership${total === 1 ? "" : "s"}`;
    if (refs.accessMore) refs.accessMore.hidden = !payload.pagination?.has_more;
    if (!customers.length) {
      refs.accessList.innerHTML = '<tr><td colspan="6">No access memberships for this search.</td></tr>';
      return;
    }
    refs.accessList.innerHTML = customers.map((customer) => {
      const nextOperation = customer.status === "active" ? "revoke" : "reactivate";
      const nextLabel = customer.status === "active" ? "Revoke future access" : "Reactivate";
      const source = customer.source_release_id || customer.source_type || "manual";
      return `<tr data-access-id="${escapeHtml(customer.access_id)}">
        <td data-label="Customer">${escapeHtml(customer.customer_email_masked || "Account")}${customer.identity_verified ? "" : "<small>Shopify ID pending</small>"}</td>
        <td data-label="Status"><span class="kob-mpc__access-state${customer.status === "revoked" ? " kob-mpc__access-state--revoked" : ""}">${escapeHtml(customer.status)}</span></td>
        <td data-label="Reserved">${Number(customer.reserved_quantity || 0)}</td>
        <td data-label="Source">${escapeHtml(source)}</td>
        <td data-label="Updated">${escapeHtml(formatDate(customer.updated_at))}</td>
        <td data-label="Action"><button class="kob-mpc-button${nextOperation === "revoke" ? " kob-mpc-button--danger" : ""}" type="button" data-kob-mpc-access-action="${nextOperation}" data-access-id="${escapeHtml(customer.access_id)}" data-revision="${Number(customer.revision || 0)}">${nextLabel}</button></td>
      </tr>`;
    }).join("");
  }

  function renderAccessEvents(events) {
    if (!events.length) {
      refs.accessEvents.innerHTML = "<p>No access changes recorded.</p>";
      return;
    }
    refs.accessEvents.innerHTML = events.map((event) => `<article>
      <div><strong>${escapeHtml(event.event_type)} · ${escapeHtml(event.customer_email_masked || "Release")}</strong>
      <span>${escapeHtml(event.reason || "No reason recorded")} · by ${escapeHtml(event.actor_email_masked || "owner")}</span></div>
      <time datetime="${escapeHtml(event.created_at)}">${escapeHtml(formatDate(event.created_at))}</time>
    </article>`).join("");
  }

  function accessReason() {
    return String(refs.accessReason?.value || "").trim();
  }

  function accessRequestId(prefix) {
    const suffix = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    return `${prefix}:${suffix}`;
  }

  async function applyAccessChange(payload, successMessage, reasonOverride = "") {
    const reason = String(reasonOverride || accessReason()).trim();
    if (!reason) {
      toast("Enter an internal audit reason before changing customer access.");
      refs.accessReason?.focus();
      return null;
    }
    const result = await api("/makeup-preorder-operations/access-apply", {
      method: "POST",
      body: JSON.stringify({
        ...payload,
        release_id: state.releaseId,
        reason,
        request_id: accessRequestId(`ACCESS-${String(payload.operation || "change").toUpperCase()}`),
        confirmation: "SAVE ACCESS CUSTOMERS",
      }),
    });
    state.accessLookupCustomer = null;
    state.accessCopyPlan = null;
    refs.accessAdd.disabled = true;
    refs.accessCopyApply.disabled = true;
    await refreshExpandedAccess();
    toast(successMessage);
    return result;
  }

  function setWorkflowStage({ stage, title, copy, stateLabel, blocker = "", actionLabel, actionType, target = null }) {
    const stageChanged = state.workflowStage !== stage;
    state.workflowStage = stage;
    root.dataset.workflowStage = String(stage);
    const phase = stage <= 2 ? "announcement" : (stage === 3 ? "customer" : (stage <= 5 ? "supply" : "arrival"));
    refs.progress?.querySelectorAll("[data-phase]").forEach((item) => {
      const itemPhase = item.dataset.phase;
      const parallelAvailable = stage >= 3 && stage < 6 && ["customer", "supply"].includes(itemPhase);
      item.classList.toggle("is-available", parallelAvailable && itemPhase !== phase);
      item.classList.toggle("is-current", itemPhase === phase);
      if (itemPhase === phase) item.setAttribute("aria-current", "step");
      else item.removeAttribute("aria-current");
    });
    refs.nextTitle.textContent = title;
    refs.nextCopy.textContent = copy;
    refs.nextState.textContent = stateLabel;
    refs.nextBlocker.textContent = blocker;
    refs.nextBlocker.hidden = !blocker;
    refs.nextAction.textContent = actionLabel;
    state.nextAction = { type: actionType, target };
    refs.arrivalHandoff.hidden = !state.payload?.workflow;

    if (stageChanged && target?.tagName === "DETAILS") target.open = true;
  }

  function updateWorkflow(payload) {
    const hasWorkflow = Boolean(payload.workflow && payload.release);
    if (!hasWorkflow) {
      setWorkflowStage({
        stage: 1,
        title: "Check the latest announcement",
        copy: "Preview the latest Miyazawa bundle first. Import remains a separate confirmed D1/R2 action.",
        stateLabel: "Waiting for announcement",
        actionLabel: "Check latest announcement",
        actionType: "announcement-preview",
      });
      return;
    }

    const drafts = payload.order_drafts || [];
    const importNeedsReview = payload.workflow.import_status === "review";
    const published = payload.workflow.publication_status === "published";
    const activeDraft = drafts.find((row) => ["preparing", "replacing", "draft_created", "recovery_required"].includes(row.status));
    const draftCreated = activeDraft?.status === "draft_created";
    const draftRecoveryRequired = activeDraft?.status === "recovery_required";
    const draftPreparing = ["preparing", "replacing"].includes(activeDraft?.status);
    const coverageGap = Number(payload.totals?.coverage_gap_qty || payload.totals?.addon_needed_qty || 0);
    const strategicGap = (payload.supplier_summary || []).reduce((sum, row) => sum + Number(row.strategic_gap_qty || 0), 0);
    const publishedModels = payload.published_models || [];
    const openModels = publishedModels.filter((line) => line.preorder_close_at && Date.parse(line.preorder_close_at) > Date.now()).length;
    const unknownDates = publishedModels.some((line) => !line.preorder_close_at || !Number.isFinite(Date.parse(line.preorder_close_at)));
    const customerState = !published ? (importNeedsReview ? "Waiting for review" : "Ready to open")
      : (!publishedModels.length || unknownDates ? "Published · check model deadlines"
        : (openModels ? `${openModels} of ${publishedModels.length} models accepting reservations` : "Reservations closed"));
    refs.customerLane.textContent = `${customerState} · ${Number(payload.totals?.customer_preorder_qty || 0)} paid units`;
    const unpublishedChanges = published && Number(payload.workflow.review_revision || 0) !== Number(payload.workflow.published_review_revision || 0);
    refs.customerGuidance.textContent = importNeedsReview ? "Save model settings first. Customer opening and early supplier orders then become available independently."
      : (unpublishedChanges ? "Saved settings differ from the last publication. Review the changes before updating customer access and product policies. Existing inventory is preserved."
        : (published ? `${customerState}. Supplier orders remain independent. Check the customer page for live availability.` : "Ready to review customer opening. Early supplier orders can be prepared before opening or collecting payment."));
    refs.supplyLane.textContent = activeDraft
      ? `${Number(payload.totals?.draft_pending_qty || 0)} in Draft · not coverage`
      : `${Number(payload.totals?.supplier_ordered_qty || 0)} SENT · ${coverageGap} gap`;

    if (importNeedsReview) {
      setWorkflowStage({
        stage: 2,
        title: "Review parsed products",
        copy: "Confirm codes, prices, customer limits and deadlines before any downstream action.",
        stateLabel: `${payload.lines.length} product${payload.lines.length === 1 ? "" : "s"} need review`,
        blocker: "Opening reservations and preparing supplier quantities stay blocked until this review is saved.",
        actionLabel: "Continue product review",
        actionType: "reveal",
        target: refs.reviewPanel,
      });
    } else if (draftRecoveryRequired || draftPreparing) {
      setWorkflowStage({
        stage: 5,
        title: draftRecoveryRequired ? "Recover the unresolved Gmail Draft" : (activeDraft.status === "replacing" ? "Wait for Gmail Draft replacement to finish" : "Wait for Gmail Draft creation to finish"),
        copy: "This release is locked against another Draft. Do not create or retry a supplier order until the saved attempt is resolved.",
        stateLabel: draftRecoveryRequired ? "Gmail outcome requires recovery" : "Supplier Draft creation in progress",
        blocker: "Pending quantities are not supplier coverage.",
        actionLabel: "Review Draft recovery status",
        actionType: "reveal",
        target: refs.activeOrders,
      });
    } else if (draftCreated) {
      setWorkflowStage({
        stage: 5,
        title: "Send the reviewed Gmail Draft, then verify SENT",
        copy: "The Draft is pending only. Coverage changes after this page verifies a SENT message.",
        stateLabel: "Supplier Draft awaiting confirmation",
        blocker: "Do not treat Draft quantities as supplier coverage.",
        actionLabel: "Review Draft and sent status",
        actionType: "reveal",
        target: refs.activeOrders,
      });
    } else if (strategicGap > 0) {
      setWorkflowStage({
        stage: 4,
        title: "Secure priority SKUs early",
        copy: "Review the cumulative Secure early targets before paid demand arrives. Customer reservations remain an independent parallel action.",
        stateLabel: `${strategicGap} strategic unit${strategicGap === 1 ? "" : "s"} not yet covered`,
        blocker: payload.gmail_draft_writes_enabled ? "" : "Supplier Gmail Draft creation is locked; preview remains available.",
        actionLabel: "Review secure-early coverage",
        actionType: "reveal",
        target: refs.orderTools,
      });
    } else if (coverageGap > 0) {
      setWorkflowStage({
        stage: 4,
        title: "Cover paid and partner demand",
        copy: "Plan only the gap between the higher of binding demand or secure target and cumulative SENT coverage.",
        stateLabel: `${coverageGap} unit${coverageGap === 1 ? "" : "s"} uncovered`,
        blocker: payload.gmail_draft_writes_enabled ? "" : "Supplier Gmail Draft creation is locked; calculation remains available.",
        actionLabel: "Review supplier coverage",
        actionType: "reveal",
        target: refs.orderTools,
      });
    } else if (!published || unpublishedChanges) {
      setWorkflowStage({
        stage: 3,
        title: unpublishedChanges ? "Review saved changes for customer publication" : "Review customer opening when ready",
        copy: "There is no supplier coverage gap now. Customer opening and early supplier ordering remain independent; neither must wait for the other.",
        stateLabel: unpublishedChanges ? "Saved settings differ from publication" : "Customer opening available",
        actionLabel: "Review customer reservations", actionType: "reveal", target: refs.publicationTools,
      });
    } else {
      setWorkflowStage({
        stage: 6,
        title: "No supplier order needed right now",
        copy: "Current demand and early-order targets have no remaining gap. You can adjust early-order targets for popular models while reservations continue independently.",
        stateLabel: "No current coverage gap",
        actionLabel: "View current coverage",
        actionType: "reveal",
        target: root.querySelector(".kob-mpc__coverage"),
      });
    }
  }

  function placeReviewWorkspace(payload) {
    const needsReview = payload.workflow?.import_status === "review";
    const placement = needsReview ? "primary" : "saved";
    if (refs.reviewPanel.previousElementSibling !== refs.reviewAnchor) refs.reviewAnchor.after(refs.reviewPanel);
    if (placement === "primary") {
      if (refs.reviewPanel.previousElementSibling !== refs.reviewAnchor) refs.reviewAnchor.after(refs.reviewPanel);
      refs.reviewEyebrow.textContent = "Announcement and release setup";
      refs.reviewTitle.textContent = "Review products and supply strategy";
      refs.reviewCopy.textContent = "Review customer caps and supply strategy together. Open model details for prices, dates and other settings.";
      refs.reviewPanel.open = true;
    } else {
      refs.reviewEyebrow.textContent = "Completed release setup";
      refs.reviewTitle.textContent = "Release settings & supply strategy";
      refs.reviewCopy.textContent = "Adjust individual model dates, limits or early-order targets here. Saving does not change live prices or restore inventory.";
      if (state.reviewPlacement !== "saved") {
        refs.reviewPanel.open = false;
        refs.toolbox.open = false;
      }
    }
    state.reviewPlacement = placement;
  }

  function render(payload) {
    const hasWorkflow = Boolean(payload.workflow && payload.release);
    refs.reviewPanel.hidden = !hasWorkflow;
    refs.operate.hidden = !hasWorkflow;
    if (refs.monitor) refs.monitor.hidden = !hasWorkflow;
    refs.partners.hidden = !hasWorkflow;
    refs.history.hidden = !hasWorkflow;
    if (refs.accessPanel) refs.accessPanel.hidden = !hasWorkflow;
    summary("release", payload.release_id || "-");
    summary("products", payload.lines?.length || 0);
    summary("requested", payload.totals?.total_requested_qty || 0);
    summary("secure", payload.totals?.secure_now_qty || 0);
    summary("draft", payload.totals?.draft_pending_qty || 0);
    summary("ordered", payload.totals?.supplier_ordered_qty || 0);
    summary("addon", payload.totals?.coverage_gap_qty || payload.totals?.addon_needed_qty || 0);
    renderReleaseSelector(payload.releases || [], payload.release_id || "");
    if (hasWorkflow) placeReviewWorkspace(payload);
    nextPanel.querySelector(".kob-mpc__eyebrow").textContent = "Recommended action · other tasks remain available";
    updateWorkflow(payload);
    state.customerPageUrl = publishedCustomerPageUrl(payload);
    if (refs.customerPage) refs.customerPage.hidden = !state.customerPageUrl;
    if (refs.customerPageLink && state.customerPageUrl) {
      refs.customerPageLink.href = state.customerPageUrl;
      refs.customerPageLink.textContent = state.customerPageUrl;
    }
    if (!hasWorkflow) { selectWorkspace("overview", { remember: false }); return; }
    renderReview(payload);
    renderPartnerRequests(payload);
    renderDemand(payload.supplier_summary || []);
    paginateRows(refs.partnerLines, "partners");
    paginateRows(refs.demandLines, "coverage");
    renderHistory(payload.order_drafts || []);
    void hydrateProductPreviews([
      ...(payload.lines || []).map((line) => line.variant_code),
      ...(payload.supplier_summary || []).map((line) => line.variant_code),
    ]);
    refs.publicationStatus.textContent = statusLabel(payload.workflow.publication_status || "not_started");
    if (refs.publicationTarget) refs.publicationTarget.textContent = payload.release_id;
    if (refs.publicationTargetDetail) refs.publicationTargetDetail.textContent = `${payload.release.title || payload.release_id} · ${payload.lines.length} models`;
    if (!refs.accessSource.value) refs.accessSource.value = payload.current_operational_release_id || payload.release_id || "";
    refs.publish.disabled = true;
    const reviewed = payload.workflow.import_status === "reviewed";
    refs.previewPublication.disabled = !reviewed;
    renderPublicationJob(payload.publication_job);
    refs.previewOrder.disabled = !reviewed;
    const activeDraft = (payload.order_drafts || []).find((draft) => ["preparing", "replacing", "draft_created", "recovery_required"].includes(draft.status));
    refs.draftLock.textContent = activeDraft
      ? (activeDraft.status === "recovery_required" ? "Gmail Draft recovery required" : (["preparing", "replacing"].includes(activeDraft.status) ? "Gmail Draft update in progress" : "Existing Gmail Draft must be resolved"))
      : (payload.gmail_draft_writes_enabled ? "Gmail Draft enabled" : "Gmail Draft locked");
    refs.createDraft.disabled = !state.orderPreview || !payload.gmail_draft_writes_enabled || Boolean(activeDraft);
    root.querySelector("[data-kob-mpc-save-note]").textContent = payload.workflow.publication_status === "published"
      ? "Saves internal settings and order strategy. Review publication separately to update customer policies; existing prices and inventory are preserved."
      : "Save settings to enable customer opening and early supplier orders independently.";
    root.querySelector("[data-kob-mpc-save-note]").textContent += ` Saves all ${payload.lines.length} models.`;
    renderModelPicker(state.model);
    renderFlow(payload);
    selectWorkspace(state.workspace, { remember: false });
    rememberContext();
  }

  function renderReleaseSelector(releases, selectedReleaseId) {
    if (!refs.releaseSelect) return;
    refs.releaseSelect.innerHTML = releases.length
      ? releases.map((release) => `<option value="${escapeHtml(release.release_id)}"${release.release_id === selectedReleaseId ? " selected" : ""}>${escapeHtml(release.release_id)} · ${escapeHtml(release.title || release.source_day_jst || "")}</option>`).join("")
      : '<option value="">No imported release</option>';
  }

  function renderReview(payload) {
    refs.reviewForm.elements.release_id.value = payload.release_id || "";
    refs.reviewForm.elements.title.value = payload.release?.title || "";
    refs.reviewForm.elements.supplier_deadline.value = (payload.lines || []).map((line) => line.supplier_deadline).filter(Boolean).sort()[0] || "";
    refs.reviewForm.elements.close_at.value = toLocalDateTime((payload.lines || []).map((line) => line.payload?.preorder_close_at).filter(Boolean).sort()[0] || "");
    refs.importMeta.textContent = `${payload.workflow.source_day_jst || ""} / ${(payload.source_attachments || []).filter((row) => row.attachment_kind === "source_xlsx").length} workbooks`;
    refs.reviewLines.innerHTML = (payload.lines || []).map((line) => `<tr data-code="${escapeHtml(line.variant_code)}">
      <td data-label="Image"><span class="kob-mpc__model-thumbnail" data-model-thumbnail="${escapeHtml(line.variant_code)}">${modelThumbnail(line.variant_code)}</span></td>
      <td data-label="Code">${renderProductCode(line.variant_code, line.product_title)}</td>
      <td data-label="Model"><span data-model-name>${escapeHtml(line.product_title || "")}</span></td>
      <td data-label="Suggested cap"><strong data-suggested-cap></strong><small data-cap-basis></small></td>
      <td data-label="Customer cap"><input data-field="preorder_cap" type="number" min="1" step="1" required value="${inputNumber(line.preorder_cap)}" aria-label="${escapeHtml(line.variant_code)} preorder cap"><small data-cap-status></small><button type="button" class="kob-mpc__cap-reset" data-use-suggested-cap>Use suggestion</button></td>
      <td data-label="Supply strategy"><select data-field="supplier_priority" aria-label="${escapeHtml(line.variant_code)} supply strategy"><option value="normal"${line.supplier_priority === "secure_early" ? "" : " selected"}>Follow demand</option><option value="secure_early"${line.supplier_priority === "secure_early" ? " selected" : ""}>Order early</option></select><label data-secure-target><span>Cumulative secure target</span><input data-field="secure_now_qty" type="number" min="0" step="1" value="${inputNumber(line.secure_now_qty)}" aria-label="${escapeHtml(line.variant_code)} cumulative secure target"></label></td>
      <td data-label="Details" class="kob-mpc__model-details-cell"><details data-model-details><summary aria-label="${escapeHtml(line.variant_code)} details">Details</summary><div class="kob-mpc__model-details-fields">
        <label class="kob-mpc__model-title-field"><span>Product name</span><input data-field="product_title" value="${escapeHtml(line.product_title || "")}" aria-label="${escapeHtml(line.variant_code)} product title"></label>
        <label><span>Official JPY</span><input data-field="official_price_jpy" type="number" min="0" step="1" value="${inputNumber(line.official_price_jpy)}" aria-label="${escapeHtml(line.variant_code)} official price"></label>
        <label><span>Deposit JPY</span><input data-field="deposit_jpy" type="number" min="0" step="1" value="${inputNumber(line.deposit_jpy)}" aria-label="${escapeHtml(line.variant_code)} deposit"></label>
        <label><span>Limited quantity</span><input data-field="limited_pcs" type="number" min="0" step="1" value="${line.limited_pcs || ""}" aria-label="${escapeHtml(line.variant_code)} limited quantity"></label>
        <label><span>Per-account max</span><input data-field="customer_max_quantity" type="number" min="1" step="1" value="${inputNumber(line.customer_max_quantity)}" aria-label="${escapeHtml(line.variant_code)} per-account maximum quantity"></label>
        <label><span>Supplier deadline (JST)</span><input data-field="supplier_deadline" type="date" value="${escapeHtml(line.supplier_deadline || "")}" aria-label="${escapeHtml(line.variant_code)} supplier deadline"></label>
        <label><span>Customer close (JST)</span><input data-field="close_at" type="datetime-local" value="${toLocalDateTime(line.payload?.preorder_close_at || "")}" aria-label="${escapeHtml(line.variant_code)} customer close JST"></label>
        <label><span>Internal note</span><input data-field="supplier_strategy_note" maxlength="500" value="${escapeHtml(line.supplier_strategy_note || "")}" aria-label="${escapeHtml(line.variant_code)} supplier strategy note"></label>
        <small>JAN: ${escapeHtml(line.payload?.jan || "—")}</small>
      </div></details></td>
    </tr>`).join("");
    refs.reviewLines.querySelectorAll("tr[data-code]").forEach(updateModelRow);
    root.querySelector("[data-kob-mpc-bulk-models]").innerHTML = (payload.lines || []).map((line) => `<label><input type="checkbox" data-bulk-model="${escapeHtml(line.variant_code)}" aria-label="Select ${escapeHtml(line.variant_code)} for date changes">${escapeHtml(line.variant_code)}</label>`).join("");
  }

  function renderDemand(rows) {
    const activeDraft = (state.payload?.order_drafts || []).find((draft) => ["preparing", "replacing", "draft_created", "recovery_required"].includes(draft.status));
    refs.demandLines.innerHTML = rows.length ? rows.map((row) => {
      const gap = Number(row.coverage_gap_qty || 0);
      const gapAction = gap > 0
        ? `<span class="kob-mpc__gap-badge">Needs SENT coverage +${number(gap)}</span><button class="kob-mpc-button kob-mpc-button--quiet" type="button" ${activeDraft ? "data-review-active-draft" : "data-review-gap"}>${activeDraft ? "Review existing Draft" : "Review order"}</button>`
        : "";
      return `<div class="kob-mpc__data-grid-row${gap > 0 ? " is-alert" : ""}" role="row" data-code="${escapeHtml(String(row.variant_code || "").toUpperCase())}">
      <div class="kob-mpc__data-grid-cell" data-label="Code" role="cell">${renderProductCode(row.variant_code, row.product_title, row.product_title || "")}</div>
      <div class="kob-mpc__data-grid-cell" data-label="Strategy" role="cell">${row.supplier_priority === "secure_early" ? "Secure early" : "Normal"}</div>
      <div class="kob-mpc__data-grid-cell" data-label="Secure target" role="cell">${number(row.secure_now_qty)}</div>
      <div class="kob-mpc__data-grid-cell" data-label="Paid" role="cell">${number(row.customer_preorder_qty)}</div>
      <div class="kob-mpc__data-grid-cell" data-label="Partner" role="cell">${number(row.partner_requested_qty)}</div>
      <div class="kob-mpc__data-grid-cell" data-label="Binding demand" role="cell">${number(row.binding_demand_qty ?? row.total_requested_qty)}</div>
      <div class="kob-mpc__data-grid-cell" data-label="Draft" role="cell">${number(row.draft_pending_qty)}</div>
      <div class="kob-mpc__data-grid-cell" data-label="SENT" role="cell">${number(row.supplier_ordered_qty)}</div>
      <div class="kob-mpc__data-grid-cell" data-label="Gap" role="cell"><strong>${number(row.coverage_gap_qty)}</strong>${gapAction}</div>
      <div class="kob-mpc__data-grid-cell" data-label="Exposure" role="cell">${number(row.exposure_qty)}</div>
    </div>`;
    }).join("") : '<div class="kob-mpc__data-grid-empty">No products loaded.</div>';
  }

  function renderPartnerRequests(payload) {
    const requests = payload.partner_requests || [];
    const requestQuantity = (code, alias) => Number(requests.find((row) => (
      String(row.variant_code || "").toUpperCase() === code
      && String(row.partner_alias || "").toLowerCase() === alias.toLowerCase()
    ))?.requested_qty || 0);
    refs.partnerLines.innerHTML = (payload.supplier_summary || []).map((row) => {
      const code = String(row.variant_code || "").toUpperCase();
      const kai = requestQuantity(code, "KOB1003");
      const dai = requestQuantity(code, "Azzurr0");
      const gap = Math.max(Number(row.customer_preorder_qty || 0) + kai + dai - Number(row.supplier_ordered_qty || 0), 0);
      return `<div class="kob-mpc__data-grid-row${gap > 0 ? " is-alert" : ""}" role="row" data-code="${escapeHtml(code)}" data-customer="${Number(row.customer_preorder_qty || 0)}" data-ordered="${Number(row.supplier_ordered_qty || 0)}">
        <div class="kob-mpc__data-grid-cell" data-label="Code" role="cell">${renderProductCode(code, row.product_title, row.product_title || "")}</div>
        <div class="kob-mpc__data-grid-cell" data-label="Kai" role="cell"><select data-partner="KOB1003" aria-label="${escapeHtml(code)} Kai request"><option value="0"${kai ? "" : " selected"}>0</option><option value="1"${kai ? " selected" : ""}>1</option></select></div>
        <div class="kob-mpc__data-grid-cell" data-label="Dai" role="cell"><select data-partner="Azzurr0" aria-label="${escapeHtml(code)} Dai request"><option value="0"${dai ? "" : " selected"}>0</option><option value="1"${dai ? " selected" : ""}>1</option></select></div>
        <div class="kob-mpc__data-grid-cell" data-label="Customer demand" role="cell">${number(row.customer_preorder_qty)}</div>
        <div class="kob-mpc__data-grid-cell" data-label="Supplier ordered" role="cell">${number(row.supplier_ordered_qty)}</div>
        <div class="kob-mpc__data-grid-cell" data-label="Gap after commitments" role="cell" data-partner-addon><strong>${number(gap)}</strong>${gap > 0 ? `<span class="kob-mpc__gap-badge">Needs SENT coverage +${number(gap)}</span>` : ""}</div>
      </div>`;
    }).join("");
  }

  function updatePartnerPreview() {
    refs.partnerLines.querySelectorAll("[data-code]").forEach((row) => {
      const partner = [...row.querySelectorAll("[data-partner]")].reduce((sum, select) => sum + Number(select.value || 0), 0);
      const gap = Math.max(Number(row.dataset.customer || 0) + partner - Number(row.dataset.ordered || 0), 0);
      const cell = row.querySelector("[data-partner-addon]");
      cell.innerHTML = `<strong>${number(gap)}</strong>${gap > 0 ? `<span class="kob-mpc__gap-badge">Needs SENT coverage +${number(gap)}</span>` : ""}`;
      row.classList.toggle("is-alert", gap > 0);
    });
  }

  function renderHistory(rows) {
    const active = rows.filter((row) => ["preparing", "replacing", "draft_created", "recovery_required"].includes(row.status));
    refs.activeOrders.hidden = !active.length;
    refs.activeOrders.innerHTML = active.map((row) => `<article><strong>${row.mode === "add-on" ? "Active add-on" : "Active initial order"} · ${number((row.plan || []).reduce((sum, line) => sum + Number(line.planned_qty || 0), 0))} units</strong><p>${escapeHtml(statusLabel(row.status))}${row.stale ? " · Demand or early-order targets changed; compare before sending." : ""}</p><button class="kob-mpc-button kob-mpc-button--primary" type="button" data-open-active-order="${escapeHtml(row.order_draft_id)}">Review active order</button></article>`).join("");
    refs.historyList.innerHTML = rows.length ? rows.map((row) => {
      const positivePlan = (row.plan || []).filter((line) => Number(line.planned_qty || 0) > 0);
      const quantity = positivePlan.reduce((sum, line) => sum + Number(line.planned_qty || 0), 0);
      const label = `${row.mode === "add-on" ? "Add-on order" : "Initial order"} / ${number(quantity)} units`;
      return `<article data-order-draft-id="${escapeHtml(row.order_draft_id)}"${row.status === "archived" ? ' class="is-archived"' : ""}><div><strong>${escapeHtml(label)}</strong><span>${escapeHtml(statusLabel(row.status))}${row.stale ? " / demand changed" : ""} / ${escapeHtml(formatDate(row.created_at))}</span></div><div><button class="kob-mpc-button" type="button" data-open-draft-detail>View details</button></div></article>`;
    }).join("") : "<p>No supplier Gmail Draft has been created.</p>";
  }

  function renderOrderPreview(preview) {
    if (preview.release_id !== state.releaseId) return;
    preview.plan = (preview.plan || []).map((line) => Object.hasOwn(state.orderEdits, line.variant_code) ? { ...line, planned_qty: state.orderEdits[line.variant_code] } : line);
    state.orderPreview = preview;
    refs.orderMode.value = preview.mode;
    refs.orderPanel.hidden = false;
    if (refs.orderPreviewTitle) refs.orderPreviewTitle.textContent = preview.mode === "add-on"
      ? `Review add-on ${String(preview.add_on_sequence || 1).padStart(2, "0")}`
      : "Review the initial supplier order";
    refs.orderLines.innerHTML = (preview.plan || []).map((line) => `<div class="kob-mpc__data-grid-row" role="row" data-code="${escapeHtml(line.variant_code)}">
      <div class="kob-mpc__data-grid-cell" data-label="Code" role="cell">${renderProductCode(line.variant_code, line.product_title, line.product_title || "")}</div>
      <div class="kob-mpc__data-grid-cell" data-label="Paid" role="cell">${number(line.customer_preorder_qty)}</div>
      <div class="kob-mpc__data-grid-cell" data-label="Partner" role="cell">${number(line.partner_requested_qty)}</div>
      <div class="kob-mpc__data-grid-cell" data-label="Secure target" role="cell">${number(line.secure_now_qty)}</div>
      <div class="kob-mpc__data-grid-cell" data-label="SENT" role="cell">${number(line.supplier_ordered_qty)}</div>
      <div class="kob-mpc__data-grid-cell" data-label="Suggested" role="cell">${number(line.suggested_qty)}</div>
      <div class="kob-mpc__data-grid-cell" data-label="This order" role="cell"><input data-planned-qty type="number" min="0" step="1" value="${inputNumber(line.planned_qty)}" aria-label="${escapeHtml(line.variant_code)} this order quantity"></div>
      <div class="kob-mpc__data-grid-cell" data-label="After SENT" role="cell" data-coverage-after>${number(line.supplier_ordered_after)}</div>
      <div class="kob-mpc__data-grid-cell" data-label="Exposure after" role="cell" data-buffer-after>${number(line.exposure_after ?? line.buffer_after)}</div>
    </div>`).join("");
    void hydrateProductPreviews((preview.plan || []).map((line) => line.variant_code));
    updateOrderTotals();
    paginateRows(refs.orderLines, "order");
    refs.createDraft.disabled = !preview.inputs_hash || !state.payload?.gmail_draft_writes_enabled
      || (state.payload?.order_drafts || []).some((draft) => ["preparing", "replacing", "draft_created", "recovery_required"].includes(draft.status));
    selectWorkspace("supplier", { task: "order" });
    refs.orderPanel.scrollIntoView({ behavior: "auto", block: "start" });
  }

  function updateOrderTotals() {
    let quantity = 0;
    refs.orderLines.querySelectorAll("[data-code]").forEach((row) => {
      const planned = Math.max(Number(row.querySelector("[data-planned-qty]")?.value || 0), 0);
      quantity += planned;
      const source = state.orderPreview?.plan?.find((line) => line.variant_code === row.dataset.code) || {};
      const after = Number(source.supplier_ordered_qty || 0) + planned;
      row.querySelector("[data-coverage-after]").textContent = number(after);
      row.querySelector("[data-buffer-after]").textContent = number(Math.max(after - Number(source.total_requested_qty || 0), 0));
    });
    refs.orderTotal.textContent = `${number(quantity)} units`;
  }

  function orderOverrides() {
    return [...refs.orderLines.querySelectorAll("[data-code]")].map((row) => ({
      variant_code: row.dataset.code,
      planned_qty: Math.max(Number(row.querySelector("[data-planned-qty]")?.value || 0), 0),
    }));
  }

  function summary(key, value) {
    const element = root.querySelector(`[data-kob-mpc-summary="${key}"]`);
    if (element) element.textContent = value;
  }

  function hasAnnouncementLines() {
    const preview = state.announcementPreview;
    return preview?.status === "new" && Boolean(preview.bundle_hash)
      && Array.isArray(preview.lines) && preview.lines.length > 0
      && preview.lines.length === Number(preview.line_count);
  }

  function canImportAnnouncement() {
    return hasAnnouncementLines() && refs.announcementReviewed?.checked;
  }

  function renderAnnouncementLines(preview) {
    refs.announcementReview.hidden = preview.status !== "new";
    refs.announcementContext.textContent = `Review ${preview.proposed_release_id} before importing. The release controls below still belong to ${state.releaseId || "the selected release"}. After import, the new release settings will open.`;
    refs.announcementFiles.textContent = `Source files: ${(preview.attachment_names || []).join(", ")}`;
    refs.announcementLines.innerHTML = hasAnnouncementLines() ? preview.lines.map((line) => {
      const fields = [
        ["Official JPY", number(line.official_price_jpy)], ["Deposit JPY", number(line.deposit_jpy)],
        ["Balance JPY", number(line.balance_jpy)], ["Limited quantity", line.limited_pcs ? number(line.limited_pcs) : "Not stated"],
        ["Customer cap", number(line.preorder_cap)], ["Per-account max", number(line.customer_max_quantity)],
        ["Supplier deadline", line.supplier_deadline || "Not stated"],
        ["Customer close (JST)", line.close_at ? new Date(line.close_at).toLocaleString("en-GB", { timeZone: "Asia/Tokyo", hour12: false }) : "Not stated"],
      ];
      return `<article data-announcement-code="${escapeHtml(line.variant_code)}"><h3>${escapeHtml(line.variant_code)} · ${escapeHtml(line.product_title)}</h3><p>${escapeHtml(line.source_file_name || "")}</p><dl>${fields.map(([label, value]) => `<div><dt>${escapeHtml(label)}</dt><dd>${escapeHtml(value)}</dd></div>`).join("")}</dl></article>`;
    }).join("") : "<p>Product details are unavailable. Check the latest announcement again before importing.</p>";
  }

  async function previewLatestAnnouncement() {
    if (state.loading) return;
    state.announcementPreview = null;
    refs.announcementReviewed.checked = false;
    refs.announcementCandidate.hidden = true;
    setLoading(true);
    try {
      const preview = await api("/makeup-preorder-operations/gmail-import-preview", { method: "POST", body: "{}" });
      state.announcementPreview = preview;
      refs.announcementCandidate.hidden = false;
      refs.importAnnouncement.hidden = preview.status !== "new";
      refs.openDuplicate.hidden = preview.status !== "duplicate";
      refs.announcementTitle.textContent = preview.status === "duplicate"
        ? "This announcement is already imported"
        : (preview.status === "release_id_conflict" ? "Release ID conflict" : `New announcement · ${preview.source_day_jst}`);
      refs.announcementCopy.textContent = preview.status === "release_id_conflict"
        ? `${preview.proposed_release_id} already belongs to a different attachment bundle. Nothing was imported.`
        : `${preview.message_count} email${preview.message_count === 1 ? "" : "s"}, ${preview.workbook_count} workbook${preview.workbook_count === 1 ? "" : "s"}, ${preview.zip_count} ZIP, ${preview.line_count} product line${preview.line_count === 1 ? "" : "s"}. Preview is read-only.`;
      renderAnnouncementLines(preview);
      refs.announcementCandidate.scrollIntoView({ behavior: "smooth", block: "start" });
      toast(preview.status === "new" ? "Announcement preview is ready. No D1 or R2 record was written." : "Announcement checked. No import was performed.");
    } catch (error) {
      toast(`Announcement preview failed: ${error.message}`);
    } finally { setLoading(false); }
  }

  async function importReviewedAnnouncement() {
    const preview = state.announcementPreview;
    if (state.loading || !canImportAnnouncement()) return;
    if (!discardEdits()) return;
    if (!window.confirm(`Import ${preview.line_count} reviewed product lines as ${preview.proposed_release_id}? This writes a D1 draft and private R2 source files only.`)) return;
    setLoading(true);
    try {
      const payload = await api("/makeup-preorder-operations/gmail-import", { method: "POST", body: JSON.stringify({
        release_id: preview.proposed_release_id,
        expected_bundle_hash: preview.bundle_hash,
        english_title_review: preview.english_title_review || null,
        confirmation: "IMPORT PREORDER ANNOUNCEMENT",
      }) });
      refs.announcementCandidate.hidden = true;
      state.announcementPreview = null;
      await load(payload.release_id);
      setLoading(false);
      selectWorkspace("settings");
      if (!refs.reviewPanel.hidden) {
        if (refs.toolbox.contains(refs.reviewPanel)) refs.toolbox.open = true;
        refs.reviewPanel.open = true;
        refs.reviewPanel.scrollIntoView({ behavior: "auto", block: "start" });
        refs.reviewForm.elements.title.focus({ preventScroll: true });
      }
      toast(payload.duplicate ? `Announcement already imported as ${payload.release_id}.` : `Imported ${payload.line_count} products into a D1 draft and private R2 only.`);
    } catch (error) { toast(`Import failed: ${error.message}`); } finally { setLoading(false); }
  }

  refs.nextAction.addEventListener("click", async () => {
    if (state.nextAction?.type === "announcement-preview") {
      await previewLatestAnnouncement();
      return;
    }
    const target = state.nextAction?.target;
    if (!target) return;
    revealTask(target);
    if (state.nextAction?.type === "navigate") {
      target.querySelector("a[href]")?.click();
      return;
    }
    const ancestorDetails = [];
    let ancestor = target.parentElement?.closest("details");
    while (ancestor && root.contains(ancestor)) {
      ancestorDetails.unshift(ancestor);
      ancestor = ancestor.parentElement?.closest("details");
    }
    ancestorDetails.forEach((details) => { details.open = true; });
    if (target.tagName === "DETAILS") target.open = true;
    target.hidden = false;
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    const focusTarget = target.querySelector("button:not([disabled]), a[href], input:not([disabled]), select:not([disabled])");
    window.setTimeout(() => focusTarget?.focus({ preventScroll: true }), 350);
  });

  refs.checkAnnouncement?.addEventListener("click", previewLatestAnnouncement);
  refs.activeOrders?.addEventListener("click", (event) => {
    const button = event.target.closest("[data-open-active-order]");
    if (button) openDraftModal(button.dataset.openActiveOrder, button);
  });
  root.querySelectorAll("[data-kob-mpc-workspace]").forEach((button) => button.addEventListener("click", () => {
    selectWorkspace(button.dataset.kobMpcWorkspace);
  }));
  root.querySelectorAll("[data-kob-mpc-supplier-task]").forEach((button) => button.addEventListener("click", () => selectWorkspace("supplier", { task: button.dataset.kobMpcSupplierTask })));
  root.querySelector("[data-kob-mpc-flow]").addEventListener("click", (event) => {
    const button = event.target.closest("[data-flow-workspace]");
    if (button) selectWorkspace(button.dataset.flowWorkspace, { task: button.dataset.flowTask || state.supplierTask });
  });
  root.querySelector("[data-kob-mpc-resume-action]").addEventListener("click", () => {
    const resume = state.resumeContext;
    if (!resume) return;
    state.model = resume.model || "";
    state.modelSearch = "";
    root.querySelector("[data-kob-mpc-model-search]").value = "";
    renderModelPicker(state.model);
    selectWorkspace(resume.workspace, { task: resume.task });
    if (resume.workspace === "supplier" && resume.draft && draftById(resume.draft)) openDraftModal(resume.draft);
  });
  root.querySelector("[data-kob-mpc-model-search]").addEventListener("input", (event) => {
    state.modelSearch = event.target.value; state.pages.settings = 0; renderModelPicker(); rememberContext();
  });
  root.querySelector("[data-kob-mpc-model-search]").addEventListener("keydown", (event) => { if (event.key === "Enter") event.preventDefault(); });
  for (const [direction, offset] of [["prev", -1], ["next", 1]]) root.querySelector(`[data-kob-mpc-model-${direction}]`).addEventListener("click", () => {
    state.pages.settings = Number(state.pages.settings || 0) + offset;
    renderModelPicker(); rememberContext();
    root.querySelector(".kob-mpc__model-browser").scrollIntoView({ block: "start" });
  });
  refs.reviewLines.addEventListener("focusin", (event) => {
    const row = event.target.closest("tr[data-code]");
    if (row) {
      state.model = row.dataset.code;
      refs.reviewLines.querySelectorAll("tr[data-code]").forEach((item) => item.classList.toggle("is-current-model", item === row));
      locationLabel.textContent = `${workspaceLabels.settings} / ${state.model}`;
      rememberContext();
    }
  });
  for (const type of ["input", "change"]) refs.reviewLines.addEventListener(type, (event) => {
    const row = event.target.closest("tr[data-code]");
    if (row) updateModelRow(row);
  });
  refs.reviewLines.addEventListener("click", (event) => {
    const button = event.target.closest("[data-use-suggested-cap]");
    if (!button) return;
    const row = button.closest("tr[data-code]");
    const limited = Number(row.querySelector('[data-field="limited_pcs"]').value || 0);
    row.querySelector('[data-field="preorder_cap"]').value = limited > 0 ? Math.ceil(limited * .05) : 20;
    updateModelRow(row); markDirty("settings");
  });
  refs.reviewForm.addEventListener("invalid", (event) => {
    const row = event.target.closest("tr[data-code]");
    if (row) {
      state.modelSearch = ""; state.model = row.dataset.code;
      root.querySelector("[data-kob-mpc-model-search]").value = "";
      if (event.target.closest("[data-model-details]")) row.querySelector("[data-model-details]").open = true;
      if (event.target.closest("[data-secure-target]")) row.querySelector("[data-secure-target]").hidden = false;
      renderModelPicker(state.model); selectWorkspace("settings");
    }
  }, true);
  root.querySelector("[data-kob-mpc-select-models]")?.addEventListener("click", () => {
    const boxes = [...root.querySelectorAll("[data-bulk-model]")];
    const checked = boxes.some((box) => !box.checked);
    boxes.forEach((box) => { box.checked = checked; });
  });
  root.querySelector("[data-kob-mpc-apply-dates]")?.addEventListener("click", () => {
    const supplier = root.querySelector("[data-kob-mpc-bulk-supplier]").value;
    const close = root.querySelector("[data-kob-mpc-bulk-close]").value;
    const selected = new Set([...root.querySelectorAll("[data-bulk-model]:checked")].map((box) => box.dataset.bulkModel));
    const rows = [...refs.reviewLines.querySelectorAll("tr[data-code]")].filter((row) => selected.has(row.dataset.code));
    if (!rows.length || (!supplier && !close)) return toast("Select models and enter at least one date. Blank fields keep each model's current date.");
    const changes = rows.map((row) => `${row.dataset.code}: ${supplier ? `supplier ${row.querySelector('[data-field="supplier_deadline"]').value || "not set"} → ${supplier}` : ""}${close ? ` customer ${row.querySelector('[data-field="close_at"]').value || "not set"} → ${close}` : ""}`);
    if (!window.confirm(`Apply these JST date changes to ${rows.length} selected models? Save the model settings afterward.\n\n${changes.join("\n")}`)) return;
    rows.forEach((row) => {
      if (supplier) row.querySelector('[data-field="supplier_deadline"]').value = supplier;
      if (close) row.querySelector('[data-field="close_at"]').value = close;
    });
    markDirty("settings");
    toast(`Dates updated for ${rows.length} selected models. Save the settings to keep these changes.`);
  });
  refs.announcementReviewed?.addEventListener("change", () => {
    refs.importAnnouncement.disabled = state.loading || !canImportAnnouncement();
  });
  refs.importAnnouncement?.addEventListener("click", importReviewedAnnouncement);
  refs.openDuplicate?.addEventListener("click", async () => {
    const releaseId = state.announcementPreview?.duplicate_release_id || "";
    if (!releaseId) return;
    if (!discardEdits()) return;
    setLoading(true);
    try { await load(releaseId); refs.announcementCandidate.hidden = true; }
    catch (error) { toast(`Release load failed: ${error.message}`); }
    finally { setLoading(false); }
  });
  refs.releaseSelect?.addEventListener("change", async () => {
    if (!refs.releaseSelect.value || refs.releaseSelect.value === state.releaseId) return;
    if (!discardEdits()) { refs.releaseSelect.value = state.releaseId; return; }
    setLoading(true);
    try { await load(refs.releaseSelect.value); } catch (error) { toast(`Release load failed: ${error.message}`); } finally { setLoading(false); }
  });

  refs.refresh.addEventListener("click", async () => {
    if (!discardEdits()) return;
    setLoading(true);
    try { await load(); toast("Preorder operations refreshed."); } catch (error) { toast(`Refresh failed: ${error.message}`); } finally { setLoading(false); }
  });

  refs.reviewForm.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (state.loading) return;
    // Validate one field at a time so later off-page errors cannot hide the first.
    const invalid = [...refs.reviewForm.querySelectorAll("input, select, textarea")].find((input) => input.willValidate && !input.validity.valid);
    if (invalid) { invalid.reportValidity(); return; }
    const form = new FormData(refs.reviewForm);
    const lines = [...refs.reviewLines.querySelectorAll("tr[data-code]")].map((row) => {
      const previous = state.payload.lines.find((line) => line.variant_code === row.dataset.code) || {};
      const official = Number(row.querySelector('[data-field="official_price_jpy"]').value || 0);
      const deposit = Number(row.querySelector('[data-field="deposit_jpy"]').value || 0);
      return {
        ...previous,
        payload: { ...(previous.payload || {}), source_supplier_deadline: previous.payload?.source_supplier_deadline || previous.supplier_deadline || "" },
        variant_code: row.dataset.code,
        product_title: row.querySelector('[data-field="product_title"]').value,
        official_price_jpy: official,
        deposit_jpy: deposit,
        balance_jpy: Math.max(official - deposit, 0),
        limited_pcs: row.querySelector('[data-field="limited_pcs"]').value,
        preorder_cap: row.querySelector('[data-field="preorder_cap"]').value,
        customer_max_quantity: row.querySelector('[data-field="customer_max_quantity"]').value,
        supplier_priority: row.querySelector('[data-field="supplier_priority"]').value,
        secure_now_qty: row.querySelector('[data-field="secure_now_qty"]').value,
        supplier_strategy_note: row.querySelector('[data-field="supplier_strategy_note"]').value,
        supplier_deadline: row.querySelector('[data-field="supplier_deadline"]').value,
        close_at: row.querySelector('[data-field="close_at"]').value === toLocalDateTime(previous.payload?.preorder_close_at || "")
          ? previous.payload?.preorder_close_at || "" : fromLocalDateTime(row.querySelector('[data-field="close_at"]').value),
      };
    });
    const incompleteStrategy = lines.find((line) => line.supplier_priority === "secure_early" && Number(line.secure_now_qty || 0) < 1);
    if (incompleteStrategy) {
      state.modelSearch = ""; root.querySelector("[data-kob-mpc-model-search]").value = "";
      renderModelPicker(incompleteStrategy.variant_code); selectWorkspace("settings");
      refs.reviewLines.querySelector(`[data-code="${CSS.escape(incompleteStrategy.variant_code)}"] [data-field="secure_now_qty"]`).focus();
      toast(`${incompleteStrategy.variant_code}: enter a positive cumulative secure target or choose Follow demand.`);
      return;
    }
    setLoading(true);
    try {
      await api("/makeup-operations/release-draft", { method: "POST", body: JSON.stringify({
        release_id: state.releaseId, title: form.get("title"),
        expected_revision: Number(state.payload.workflow.review_revision || 0),
        supplier_deadline: lines.map((line) => line.supplier_deadline).filter(Boolean).sort()[0] || "",
        close_at: lines.map((line) => line.close_at).filter(Boolean).sort()[0] || "", source_type: "gmail",
        source_message_id: state.payload.release?.source_message_id || "",
        source_attachment_hash: state.payload.release?.source_attachment_hash || "",
        lines,
      }) });
      state.dirty.delete("settings");
      state.payload.workflow.review_revision = Number(state.payload.workflow.review_revision || 0) + 1;
      state.payload.lines = lines.map((line) => ({ ...line, payload: { ...line.payload, preorder_close_at: line.close_at } }));
      await load();
      toast("Reviewed release draft saved. No product was published and no email was created.");
    } catch (error) { toast(`Save failed: ${error.message}`); } finally { setLoading(false); }
  });

  refs.previewOrder.addEventListener("click", async () => {
    if (state.dirty.has("settings") || state.dirty.has("partners")) return toast("Save model settings and partner commitments before reviewing an order.");
    setLoading(true);
    try {
      const strategicGap = (state.payload?.supplier_summary || []).reduce((sum, row) => sum + Number(row.strategic_gap_qty || 0), 0);
      const preview = await api("/makeup-preorder-operations/order-preview", { method: "POST", body: JSON.stringify({
        release_id: state.releaseId,
        planning_basis: strategicGap > 0 ? "secure_early" : "demand_coverage",
      }) });
      renderOrderPreview(preview);
      toast(`${preview.mode === "add-on" ? "Add-on" : "Initial"} order calculated from binding demand, cumulative secure targets and SENT coverage.`);
    } catch (error) { toast(`Order preview failed: ${error.message}`); } finally { setLoading(false); }
  });

  refs.previewPublication.addEventListener("click", async () => {
    if (state.dirty.has("settings")) return toast("Save model settings before reviewing publication.");
    setLoading(true);
    try {
      state.publicationPreview = null;
      refs.publish.disabled = true;
      let preview;
      do {
        preview = await api("/makeup-preorder-operations/publication-preview", { method: "POST", body: JSON.stringify({
          release_id: state.releaseId, access_source_release_id: refs.accessSource.value,
          publication_review: preview?.publication_review,
        }) });
        refs.publicationNote.textContent = `Checking products: ${preview.reviewed_count || preview.products?.length || 0} / ${preview.total_count || preview.products?.length || 0}. No products are being published.`;
      } while (preview.preview_complete === false);
      state.publicationPreview = preview;
      preview.requested_access_source_release_id = refs.accessSource.value;
      const creating = (preview.products || []).filter((product) => product.action === "create_unlisted").length;
      const existing = (preview.products || []).length - creating;
      const issues = preview.blocking_issues || [];
      const issueLabels = { missing_customer_deadline: "Set a customer deadline in JST", missing_supplier_deadline: "Set a supplier deadline", missing_product_image: "Add a product image", missing_product_title: "Set a product title", missing_official_price: "Set the official price", release_draft_not_reviewed: "Save the model review first", allowlist_source_empty: "The selected customer source is empty", existing_product_sku_mismatch: "The existing Shopify product has a different code" };
      const issueText = issues.map((issue) => { const [key, ...detail] = issue.split(":"); return `${detail.length ? `${detail.join(" / ")}: ` : ""}${issueLabels[key] || key}`; });
      refs.publicationNote.textContent = issues.length
        ? `${preview.release_id} — Blocked: ${issueText.join(" / ")}`
        : `${preview.release_id}: ${creating} unlisted products to create, ${existing} existing products to reuse, ${preview.access_count} invited customers from ${preview.access_source_release_id || preview.requested_access_source_release_id}, page ${preview.page_action}.`;
      refs.publish.disabled = issues.length > 0 || !preview.publication_writes_enabled || !preview.review_hash;
      toast(issues.length ? "Publication preview found blocking issues." : (preview.publication_writes_enabled ? "Publication preview is ready for confirmation." : "Publication preview passed. Production writes remain locked."));
    } catch (error) { toast(`Publication preview failed: ${error.message}`); } finally { setLoading(false); }
  });

  refs.publish.addEventListener("click", async () => {
    if (!state.publicationPreview || refs.publish.disabled) return;
    const preview = state.publicationPreview;
    if (preview.release_id !== state.releaseId || preview.requested_access_source_release_id !== refs.accessSource.value) {
      state.publicationPreview = null; refs.publish.disabled = true;
      return toast("The release or customer source changed. Review publication again.");
    }
    if (!window.confirm(`Publish ${preview.release_id} with customer eligibility copied from ${preview.access_source_release_id || preview.requested_access_source_release_id}? New products receive this batch's reviewed stock caps. Existing products keep their current price and inventory; only their preorder copy and account limits are updated.`)) return;
    setLoading(true);
    try {
      let payload = await api("/makeup-preorder-operations/publish", { method: "POST", body: JSON.stringify({
        release_id: state.releaseId,
        access_source_release_id: refs.accessSource.value,
        expected_review_hash: preview.review_hash,
        publication_review: preview.publication_review,
        confirmation: "PUBLISH PREORDER",
      }) });
      if (payload.job_id) payload = await continuePublication(payload);
      await load();
      state.publicationPreview = null;
      toast(`Preorder published: ${payload.product_count} products and ${payload.access_count} invited customers.`);
    } catch (error) {
      await load().catch(() => {});
      toast(`Publication paused: ${error.message}. Saved progress is available below.`);
    } finally { setLoading(false); }
  });

  function renderPublicationJob(job) {
    const pending = job && job.status !== "complete";
    if (refs.publicationProgress) {
      refs.publicationProgress.hidden = !pending;
      refs.publicationProgress.textContent = pending
        ? `${job.release_id}: ${job.completed} / ${job.total} products prepared. ${job.stage === "page_and_access" ? "Customer page and access are next." : "Progress is saved after each product."} Finish publication before changing settings or customer access.${job.last_error ? ` Paused: ${job.last_error}.` : ""}` : "";
    }
    if (refs.resumePublication) refs.resumePublication.hidden = !pending;
    if (pending) { refs.publish.disabled = true; refs.previewPublication.disabled = true; }
  }

  async function continuePublication(job) {
    while (job.status !== "complete") {
      renderPublicationJob(job);
      job = await api("/makeup-preorder-operations/publication-step", { method: "POST", body: JSON.stringify({ release_id: job.release_id, job_id: job.job_id }) });
    }
    renderPublicationJob(job);
    return job;
  }

  refs.resumePublication?.addEventListener("click", async () => {
    const job = state.payload?.publication_job;
    if (!job || job.status === "complete") return;
    setLoading(true);
    try {
      const result = await continuePublication(job);
      await load();
      toast(`Preorder published: ${result.product_count} products and ${result.access_count} invited customers.`);
    } catch (error) {
      await load().catch(() => {});
      toast(`Publication paused: ${error.message}. Progress has been saved.`);
    } finally { setLoading(false); }
  });

  refs.copyCustomerUrl?.addEventListener("click", async () => {
    if (!state.customerPageUrl) return;
    try {
      await copyText(state.customerPageUrl);
      toast("Customer preorder URL copied.");
    } catch { toast("Unable to copy the customer URL. Open the link and copy it from the browser."); }
  });

  refs.accessLookup?.addEventListener("click", async () => {
    const email = String(refs.accessEmail.value || "").trim();
    state.accessLookupCustomer = null;
    refs.accessAdd.disabled = true;
    if (!email) { toast("Enter an exact Shopify customer email."); return; }
    setLoading(true);
    try {
      const result = await api("/makeup-preorder-operations/access-customer-lookup", {
        method: "POST", body: JSON.stringify({ email }),
      });
      if (!result.found) {
        refs.accessLookupResult.textContent = `No Shopify customer matched ${result.email_masked || "that email"}.`;
        return;
      }
      state.accessLookupCustomer = result.customer;
      refs.accessLookupResult.textContent = `Shopify customer confirmed: ${result.customer.email_masked}. Review and add access separately.`;
      refs.accessAdd.disabled = false;
    } catch (error) { toast(`Customer lookup failed: ${error.message}`); } finally { setLoading(false); }
  });

  refs.accessAdd?.addEventListener("click", async () => {
    const customer = state.accessLookupCustomer;
    if (!customer) return;
    setLoading(true);
    try {
      const preview = await api("/makeup-preorder-operations/access-preview", {
        method: "POST", body: JSON.stringify({ release_id: state.releaseId, operation: "add", email: customer.email }),
      });
      if (preview.plan?.change === "unchanged") { toast("This customer already has active access."); return; }
      if (!window.confirm(`${preview.plan?.change === "reactivate" ? "Reactivate" : "Add"} ${customer.email_masked} for ${state.releaseId}? This does not send email.`)) return;
      await applyAccessChange({ operation: "add", email: customer.email }, "Allowed customer saved. No invitation email was created or sent.");
    } catch (error) { toast(`Access add failed: ${error.message}`); } finally { setLoading(false); }
  });

  refs.accessList?.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-kob-mpc-access-action]");
    if (!button) return;
    const operation = button.dataset.kobMpcAccessAction;
    const accessId = button.dataset.accessId;
    const expectedRevision = Number(button.dataset.revision || 0);
    setLoading(true);
    try {
      const preview = await api("/makeup-preorder-operations/access-preview", {
        method: "POST", body: JSON.stringify({ release_id: state.releaseId, operation, access_id: accessId, expected_revision: expectedRevision }),
      });
      const reserved = Number(preview.membership?.reserved_quantity || 0);
      const warning = operation === "revoke" && reserved > 0 ? ` Existing paid reservation quantity ${reserved} will be preserved.` : "";
      if (!window.confirm(`${operation === "revoke" ? "Revoke future access" : "Reactivate access"} for ${preview.membership?.customer_email_masked || "this customer"}?${warning}`)) return;
      await applyAccessChange(
        { operation, access_id: accessId, expected_revision: expectedRevision },
        operation === "revoke" ? "Future access revoked. Existing paid reservations were preserved." : "Customer access reactivated.",
        refs.accessToolboxReason?.value || "",
      );
    } catch (error) { toast(`Access ${operation} failed: ${error.message}`); } finally { setLoading(false); }
  });

  refs.accessCopyPreview?.addEventListener("click", async () => {
    const sourceReleaseId = String(refs.accessCopySource.value || "").trim().toUpperCase();
    if (!sourceReleaseId) { toast("Enter a source release ID."); return; }
    setLoading(true);
    try {
      const preview = await api("/makeup-preorder-operations/access-preview", {
        method: "POST", body: JSON.stringify({ release_id: state.releaseId, operation: "copy", mode: "add_only", source_release_id: sourceReleaseId }),
      });
      state.accessCopyPlan = preview;
      refs.accessCopyResult.textContent = `${preview.totals.add} to add, ${preview.totals.unchanged} unchanged, ${preview.totals.conflict} conflicts. No customers will be revoked or reactivated.`;
      refs.accessCopyApply.disabled = preview.totals.add < 1;
      toast("Add-only customer copy preview is ready.");
    } catch (error) { toast(`Access copy preview failed: ${error.message}`); } finally { setLoading(false); }
  });

  refs.accessCopyApply?.addEventListener("click", async () => {
    const preview = state.accessCopyPlan;
    if (!preview || !preview.totals?.add) return;
    if (!window.confirm(`Add ${preview.totals.add} customers from ${preview.source_release_id}? Existing and revoked memberships remain unchanged.`)) return;
    setLoading(true);
    try {
      await applyAccessChange(
        { operation: "copy", mode: "add_only", source_release_id: preview.source_release_id },
        `Added ${preview.totals.add} allowed customers. No invitation email was created or sent.`,
        refs.accessToolboxReason?.value || "",
      );
    } catch (error) { toast(`Access copy failed: ${error.message}`); } finally { setLoading(false); }
  });

  refs.accessMemberships?.addEventListener("toggle", async () => {
    if (!refs.accessMemberships.open || state.accessListLoaded) return;
    setLoading(true);
    try { await loadAccessCustomers({ reset: true }); }
    catch (error) { toast(`Membership list failed: ${error.message}`); }
    finally { setLoading(false); }
  });

  refs.accessAudit?.addEventListener("toggle", async () => {
    if (!refs.accessAudit.open) return;
    setLoading(true);
    try { await loadAccessEvents(); }
    catch (error) { toast(`Access history failed: ${error.message}`); }
    finally { setLoading(false); }
  });

  refs.accessSearchButton?.addEventListener("click", async () => {
    setLoading(true);
    try { await loadAccessCustomers({ reset: true }); }
    catch (error) { toast(`Membership search failed: ${error.message}`); }
    finally { setLoading(false); }
  });

  refs.accessSearch?.addEventListener("keydown", (event) => {
    if (event.key !== "Enter") return;
    event.preventDefault();
    refs.accessSearchButton?.click();
  });

  refs.accessClear?.addEventListener("click", async () => {
    refs.accessSearch.value = "";
    refs.accessStatus.value = "";
    setLoading(true);
    try { await loadAccessCustomers({ reset: true }); }
    catch (error) { toast(`Membership list failed: ${error.message}`); }
    finally { setLoading(false); }
  });

  refs.accessMore?.addEventListener("click", async () => {
    setLoading(true);
    try { await loadAccessCustomers(); }
    catch (error) { toast(`More memberships failed: ${error.message}`); }
    finally { setLoading(false); }
  });

  refs.orderLines.addEventListener("input", (event) => {
    if (event.target.matches("[data-planned-qty]")) {
      state.orderEdits[event.target.closest("[data-code]").dataset.code] = Number(event.target.value || 0);
      updateOrderTotals();
    }
  });

  refs.partnerLines.addEventListener("change", (event) => {
    if (event.target.matches("[data-partner]")) { markDirty("partners"); updatePartnerPreview(); }
  });

  refs.savePartners.addEventListener("click", async () => {
    const lines = [...refs.partnerLines.querySelectorAll("[data-code]")].flatMap((row) => (
      [...row.querySelectorAll("[data-partner]")].map((select) => ({
        variant_code: row.dataset.code,
        partner_alias: select.dataset.partner,
        quantity: Number(select.value || 0),
      }))
    ));
    if (!window.confirm("Save the reviewed Kai and Dai requests? Demand, buffer and add-on calculations will update immediately.")) return;
    setLoading(true);
    try {
      await api("/makeup-preorder-operations/partner-requests", { method: "POST", body: JSON.stringify({
        release_id: state.releaseId,
        lines,
        confirmation: "SAVE PARTNER REQUESTS",
      }) });
      state.dirty.delete("partners");
      await load();
      toast("Partner requests saved and supplier add-on quantities recalculated.");
    } catch (error) { toast(`Partner requests failed: ${error.message}`); } finally { setLoading(false); }
  });

  refs.createDraft.addEventListener("click", async () => {
    if (!state.orderPreview || state.orderPreview.release_id !== state.releaseId || refs.createDraft.disabled) return;
    const total = orderOverrides().reduce((sum, row) => sum + Number(row.planned_qty || 0), 0);
    if (!total) return toast("Enter at least one positive supplier order quantity.");
    if (!window.confirm(`Create a Gmail Draft with ${total} supplier-order units? This will not send the email and will not record the quantities as ordered.`)) return;
    setLoading(true);
    try {
      const payload = await api("/makeup-preorder-operations/gmail-draft", { method: "POST", body: JSON.stringify({
        release_id: state.releaseId,
        planning_basis: state.orderPreview.planning_basis,
        expected_inputs_hash: state.orderPreview.inputs_hash,
        overrides: orderOverrides(),
        confirmation: "CREATE GMAIL DRAFT",
      }) });
      state.dirty.delete("order");
      state.orderEdits = {};
      state.orderPreview = null;
      await load();
      refs.orderPanel.hidden = true;
      toast(payload.duplicate ? "This demand snapshot already has a Gmail Draft." : "Gmail Draft created with the reviewed XLSX files. Nothing was sent.");
    } catch (error) { toast(`Gmail Draft failed: ${error.message}`); } finally { setLoading(false); }
  });

  refs.demandLines.addEventListener("click", (event) => {
    if (event.target.closest("[data-review-gap]")) {
      refs.previewOrder.click();
      return;
    }
    if (event.target.closest("[data-review-active-draft]")) {
      const activeDraft = (state.payload?.order_drafts || []).find((draft) => ["preparing", "replacing", "draft_created", "recovery_required"].includes(draft.status));
      if (activeDraft) openDraftModal(activeDraft.order_draft_id, event.target.closest("button"));
    }
  });

  root.addEventListener("pointerover", (event) => {
    const trigger = event.target.closest("[data-kob-mpc-detail-trigger]");
    if (trigger) positionDetail(trigger);
  });
  root.addEventListener("focusin", (event) => {
    const trigger = event.target.closest("[data-kob-mpc-detail-trigger]");
    if (trigger) positionDetail(trigger);
  });
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-kob-mpc-detail-trigger]");
    if (!trigger || !root.contains(trigger)) {
      closeDetailTriggers();
      return;
    }
    const willOpen = !trigger.classList.contains("is-open");
    closeDetailTriggers(trigger);
    trigger.classList.toggle("is-open", willOpen);
    trigger.setAttribute("aria-expanded", String(willOpen));
    if (willOpen) positionDetail(trigger);
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeDetailTriggers();
      closeDraftModal();
    }
  });
  window.addEventListener("resize", () => closeDetailTriggers());
  window.addEventListener("scroll", () => closeDetailTriggers(), true);

  async function replaceDraftRecord(orderDraftId) {
    if (!orderDraftId || !window.confirm("Replace this unsent Gmail Draft using the saved quantities and current email template? Nothing will be sent or recorded as ordered.")) return;
    setLoading(true);
    try {
      await api("/makeup-preorder-operations/gmail-draft", { method: "POST", body: JSON.stringify({
        order_draft_id: orderDraftId,
        replace_existing: true,
        confirmation: "REPLACE GMAIL DRAFT",
      }) });
      closeDraftModal();
      await load();
      toast("Gmail Draft replaced with the saved attachments and current email template. Nothing was sent.");
    } catch (error) { toast(`Gmail Draft replacement failed: ${error.message}`); } finally { setLoading(false); }
  }

  async function reconcileDraftRecord(orderDraftId) {
    if (!orderDraftId || !window.confirm("Check the Gmail thread and record this supplier order only if the draft has actually been sent?")) return;
    setLoading(true);
    try {
      const payload = await api("/makeup-preorder-operations/reconcile-sent", { method: "POST", body: JSON.stringify({ order_draft_id: orderDraftId, confirmation: "RECORD SENT ORDER" }) });
      closeDraftModal();
      await load();
      toast(payload.duplicate ? "This sent supplier order was already recorded." : "Sent Gmail message found. Supplier quantities were recorded in D1.");
    } catch (error) { toast(`Sent-order check: ${error.message}`); } finally { setLoading(false); }
  }

  async function archiveDraftRecord(orderDraftId) {
    const reason = String(refs.archiveReason.value || "").trim();
    if (!reason) {
      toast("Enter why this Draft record should stop affecting Make Up decisions.");
      refs.archiveReason.focus();
      return;
    }
    if (!window.confirm("Archive this Make Up record? This does NOT delete the Gmail Draft. Continue only after deleting it manually in Gmail or deciding it will never be sent.")) return;
    setLoading(true);
    try {
      await api("/makeup-preorder-operations/archive-draft-record", { method: "POST", body: JSON.stringify({
        order_draft_id: orderDraftId,
        reason,
        confirmation: "ARCHIVE DRAFT RECORD",
      }) });
      closeDraftModal();
      await load();
      toast("Draft record archived. It no longer affects current counts, coverage decisions or the active-Draft lock. Gmail was unchanged.");
    } catch (error) { toast(`Draft record archive failed: ${error.message}`); } finally { setLoading(false); }
  }

  refs.historyList.addEventListener("click", (event) => {
    const button = event.target.closest("[data-open-draft-detail]");
    const orderDraftId = button?.closest("[data-order-draft-id]")?.dataset.orderDraftId || "";
    if (button && orderDraftId) openDraftModal(orderDraftId, button);
  });

  refs.draftModal?.addEventListener("click", (event) => {
    if (event.target.closest("[data-kob-mpc-modal-close]")) {
      closeDraftModal();
      return;
    }
    if (event.target.closest("[data-modal-show-archive]")) {
      refs.archivePanel.hidden = false;
      refs.archiveReason.focus();
      return;
    }
    if (event.target.closest("[data-modal-replace-draft]")) {
      void replaceDraftRecord(state.modalDraftId);
      return;
    }
    if (event.target.closest("[data-modal-reconcile]")) void reconcileDraftRecord(state.modalDraftId);
  });

  refs.archiveConfirm?.addEventListener("click", () => void archiveDraftRecord(state.modalDraftId));

  function statusLabel(value) {
    return ({ not_started: "Not started", review: "Needs review", draft_created: "Gmail Draft created", sent_recorded: "Sent and recorded", preparing: "Draft creation in progress", replacing: "Draft replacement in progress", recovery_required: "Gmail recovery required", failed: "Draft creation failed", archived: "Archived from current decisions", published: "Published" })[value] || String(value || "").replaceAll("_", " ");
  }
  function inputNumber(value) {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? String(numeric) : "";
  }
  function number(value) { return Number(value || 0).toLocaleString("en-US"); }
  function formatDate(value) { const date = new Date(value || ""); return Number.isNaN(date.getTime()) ? "" : date.toLocaleString(); }
  function toLocalDateTime(value) {
    const date = new Date(value || "");
    if (Number.isNaN(date.getTime())) return "";
    const local = new Date(date.getTime() + 9 * 3600000);
    return local.toISOString().slice(0, 16);
  }
  function fromLocalDateTime(value) { const date = new Date(value ? `${value}+09:00` : ""); return Number.isNaN(date.getTime()) ? "" : date.toISOString(); }
  function escapeHtml(value) { return String(value ?? "").replace(/[&<>"']/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[char]); }

  let initialReleaseId = "";
  try {
    initialReleaseId = new URL(window.location.href).searchParams.get("release_id")
      || window.localStorage.getItem("kob_makeup_preorder_release")
      || "";
  } catch { /* Embedded previews may not expose storage. */ }
  window.addEventListener("pagehide", clearProductPreviews, { once: true });
  load(initialReleaseId).catch((error) => toast(`Unable to load preorder operations: ${error.message}`));
  window.setInterval(() => {
    if (!state.loading && !state.dirty.size && !state.orderPreview && !state.publicationPreview && !state.modalDraftId && state.releaseId && document.visibilityState === "visible") {
      load(state.releaseId, { silent: true }).catch(() => editingNotice("Refresh failed. Displaying the last successful snapshot; use Refresh before continuing."));
    }
  }, 60000);
})();
